export const data = [
    {
      title: "2021.11.30",
      data: [
        {
          test:
            "特别说明：使用11.30引擎和2.5.6客户端的代理，版本带装备备注的，需要重新弄一下装备备注~~",
        },
        {
          test: "后台版本同步更新版号，有需要的请发代理账号即可~",
        },
        {
          test: "[2021.11.30]-32位引擎",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "01、增加删除仓库物品。",
        },
        {
          test: "格式：DelStorageItem 30004 0",
        },
        {
          test: "参数1：唯一ID或Idx",
        },
        {
          test: "参数2：0=删除所有Idx物品，1=删除物品唯一ID",
        },
        {
          test: "例子：",
        },
        {
          test: "[@main]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "DelStorageItem 30004 0",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "02、修复人物面板手镯穿戴位置不对的问题",
        },
        {
          test: "03、增加人物选择攻击模式状态选项 引擎-参数设置-状态控制",
        },
        {
          test: "04、修改魔法盾防御计算，和老传奇一样计算方式",
        },
        {
          test: "05、增加游戏GAMEID获取  常量:<$GAMEID>",
        },
        {
          test:
            "06、增加小地图备注表：cfg_mapdesc.xls  K列:是否自动传送或者寻路 0=不可以点击 1=寻路 2=传送",
        },
        {
          test: "07、增加高速 文件 读写 LoadFileToMemory",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "高速 文件 读写 LoadFileToMemory",
        },
        {
          test:
            "该命令作用是，把脚本用到的数据文件加载到内存里，脚本命令读取的时候就不用从硬盘读取该文件了",
        },
        {
          test:
            "已经在启动的的时候加载到内存，直接在内存读写，读写速度快，用在读写比较频繁的文件，比如捡取触发等等，",
        },
        {
          test: "引擎每隔一段时间，保存一次该文件，不会频繁读写硬盘。",
        },
        {
          test:
            "--------------------------------------缺点--------------------------------------",
        },
        {
          test: "不能手动修改该文件,只能通过脚本命令读写",
        },
        {
          test:
            "--------------------------------------------------------------------------------",
        },
        {
          test: "QManage.txt",
        },
        {
          test: "[@Startup]",
        },
        {
          test: "#ACT",
        },
        {
          test: "LoadFileToMemory ..\\QuestDiary\\数据\\名单.txt 0 ",
        },
        {
          test: "[@main]",
        },
        {
          test: "#IF",
        },
        {
          test: "CHECKTEXTLIST ..\\QuestDiary\\数据\\名单.txt <$USERNAME)>",
        },
        {
          test: "#SAY",
        },
        {
          test: "你的名字已经保存",
        },
        {
          test: "#ELSEACT",
        },
        {
          test: "AddTextList ..\\QuestDiary\\数据\\名单.txt <$USERNAME)>",
        },
        {
          test:
            "SENGMSG 6 写入后，已经在内存中，不会立即保存到文件里，引擎每隔一段时间自动保存，文件里可能看不见。",
        },
        {
          test:
            "SENGMSG 6 不管是否保存，使用CHECKTEXTLIST命令检测是存在的，使用了LoadFileToMemory后，所有命令都是直接检测内存的",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "08、增加客户端容器自动排版功能",
        },
        {
          test: "客户端标签：<QuickTextView>",
        },
        {
          test: "参数：",
        },
        {
          test: "x =            x坐标",
        },
        {
          test: "y=             y坐标",
        },
        {
          test: "width=         排版容器宽度",
        },
        {
          test: "height=        排版容器高度",
        },
        {
          test: "count=         每行显示多少个名单",
        },
        {
          test:
            "text=          格式（\\ 多少个为一行）996M2\\996M2\\996M2\\996M2     ",
        },
        {
          test: "例子：",
        },
        {
          test: "[@main]",
        },
        {
          test: "#IF",
        },
        {
          test: "#SAY",
        },
        {
          test:
            "<QuickTextView|x=60|y=50|width=500|height=330|count=4|text=<$STR(S$显示占领名单)>>",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "09、增加加自动挂机丢弃的物品不拾取功能",
        },
        {
          test: "10、增加M2灵魂火符、冰咆哮技能威力设置",
        },
        {
          test: "11、增加加英雄排行榜功能",
        },
        {
          test:
            "12、修复#CHILD 1/1 RANDOM 分母设置越高爆的越多，修复后分母作废。",
        },
        {
          test:
            "13、修复前端装备属性描述过多导致角色穿戴头盔、斗笠的情况下，背包里面做头盔对比 三样装备的属性栏遮挡屏幕不能关闭，已做优化处理。",
        },
        {
          test:
            "14、修复NPC给予装备或物品，放到英雄背包里面扔出去会触发系统掉落提示，修复后和人物一样背包扔出去的东西不再提示。",
        },
        {
          test:
            "15、增加扩展H.GetSlaveInfo这个命令，能取到英雄宝宝的名字功能。",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "16、重做道具物品描述",
        },
        {
          test: "例子复制：",
        },
        {
          test: "<ID=1|-#0#0&0>\\<ID=1|TXT:文字描述1/FCOLOR=250#0#0&0>\\",
        },
        {
          test: "<ID=2|-#0#0&0>\\",
        },
        {
          test: "<ID=3|IMG:res\\public\\word_jygtiao_04.png#0#0&0>\\",
        },
        {
          test: "<ID=4|-#0#0&0>\\",
        },
        {
          test: "<ID=5|TEXIAO:9#0#0#0#0&0>\\",
        },
        {
          test: "<ID=6|TXT:文字描述2/FCOLOR=250#0#0&1>\\",
        },
        {
          test: "<ID=7|-#0#0&1>\\",
        },
        {
          test: "<ID=8|IMG:res\\public\\word_jygtiao_04.png#0#0&1>\\",
        },
        {
          test: "<ID=9|-#0#0&1>\\<ID=10|TEXIAO:9#0#0#0#0&1>\\",
        },
        {
          test: "<ID=10|TXT:文字描述3/FCOLOR=250#0#0&2>\\",
        },
        {
          test: "<ID=11|-#0#0&2>\\",
        },
        {
          test: "<ID=12|IMG:res\\public\\word_jygtiao_04.png#0#0&2>\\",
        },
        {
          test: "<ID=13|-#0#0&2>\\",
        },
        {
          test: "<ID=14|TEXIAO:9#0#0#0#0&2>",
        },
        {
          test: "1：文字备注介绍",
        },
        {
          test: "ID=备注ID   一个备注中不要出现相同ID",
        },
        {
          test: "TXT:描述的备注文字",
        },
        {
          test: "FCOLOR=颜色0~255",
        },
        {
          test: "10#10  X坐标 Y坐标 ",
        },
        {
          test: "- 代表TIPS的横线",
        },
        {
          test: "&0=显示位置0=中部的位置   1=顶部的位置   2=底部的位置",
        },
        {
          test: "文字例子：",
        },
        {
          test: "<ID=1|TXT:文字描述/FCOLOR=250#10#10&0>\\<ID=2|-#0#0&0>",
        },
        {
          test:
            ";-------------------------------------------------------------------------------",
        },
        {
          test: "2：图片备注介绍",
        },
        {
          test: "ID=备注ID   一个备注中不要出现相同ID",
        },
        {
          test: "IMG=图片路径",
        },
        {
          test: "10#10  X坐标 Y坐标",
        },
        {
          test: "- 代表TIPS的横线",
        },
        {
          test: "&0=显示位置0=中部的位置   1=顶部的位置   2=底部的位置",
        },
        {
          test: "图片例子：",
        },
        {
          test:
            "<ID=2|IMG:res\\public\\word_jygtiao_04.png#10#10&0>\\<ID=2|-&0>",
        },
        {
          test:
            ";-------------------------------------------------------------------------------",
        },
        {
          test: "3：特效备注介绍",
        },
        {
          test: "ID=备注ID   一个备注中不要出现相同ID",
        },
        {
          test: "TEXIAO=特效ID",
        },
        {
          test: "10#10  X坐标 Y坐标",
        },
        {
          test: "50#50 特效宽度#特效高度",
        },
        {
          test: "- 代表TIPS的横线",
        },
        {
          test: "&0=显示位置0=中部的位置   1=顶部的位置   2=底部的位置",
        },
        {
          test: "特效例子：",
        },
        {
          test: "<ID=3|TEXIAO:9#10#10#50#50&0>\\<ID=2|-&0>",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "17、增加充值界面ID=40",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "18、增加WHILE循环脚本",
        },
        {
          test: "操作符说明: >大于 <小于 =等于 !不等于",
        },
        {
          test: "例子:",
        },
        {
          test: "[@MAIN]",
        },
        {
          test: "<111/@111> <222/@222> <$STR(N1)>",
        },
        {
          test:
            "; ******************************************尽可能不要用这种写法，递归调用容易产生栈溢出",
        },
        {
          test: "[@111]",
        },
        {
          test: "#IF",
        },
        {
          test: "SMALL N1 2000",
        },
        {
          test: "#ACT",
        },
        {
          test: "Inc N1 1",
        },
        {
          test: "SendMsg 6 > $STR(N1)>",
        },
        {
          test: "GOTO @111",
        },
        {
          test: "BREAK",
        },
        {
          test:
            ";这种脚本递归调用产生的 Stack overflow，堆栈溢出，递归层次多时有可能产生这样的问题。换成新的写法，用 while / endwhile",
        },
        {
          test: "; ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★推荐这种写法",
        },
        {
          test: "[@222]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: ";为方便测试每次执行脚本前将变量设置为1，本示例脚本可无视MOV",
        },
        {
          test: ";MOV N1 1",
        },
        {
          test:
            ";循环开始，While 变量/值 比较符号(> < =) 变量/值；循环写在 #ACT中",
        },
        {
          test: "While N1 < 1000",
        },
        {
          test: "SendMsg 6 <$STR(N1)>",
        },
        {
          test: "Inc N1 1",
        },
        {
          test: "EndWhile",
        },
        {
          test: ";循环结束 EndWhile",
        },
        {
          test: "SendMsg 6 aaaaaa",
        },
        {
          test:
            "---------------------------------------------------------------------------------",
        },
        {
          test: "19、修复登录游戏后英雄时装外观显示，需要重新勾选一次问题",
        },
        {
          test: "20、修复英雄死亡，时装掉落外观还在问题",
        },
        {
          test: "21、修复M2上面选项法师施法距离无效问题",
        },
        {
          test: "22、修复主号死亡复活后，英雄怒气值不增长问题",
        },
        {
          test: "23、修复英雄背包空格数检测无效问题",
        },
        {
          test: "24、修复挂机状态下主号攻击分身，英雄攻击分身问题",
        },
        {
          test: "25、增加获取宝宝名字的H.扩展",
        },
        {
          test: "26、增加内挂功能，宝宝跟随主人攻击目标功能",
        },
        {
          test:
            "27、修复装备属性过多，导致查看装备对比属性后，关闭不了属性界面",
        },
        {
          test: "28、增加获取游戏游戏的GAMEID常量",
        },
        {
          test: "29、增加宝宝自动召回范围 功能设置-技能魔法",
        },
        {
          test: "30、修复怪物Race=82类型 被攻击目标绿毒不显示问题",
        },
        {
          test: "31、修复防麻痹失效和复活戒指随机不复活问题",
        },
        {
          test: "32、修复商城BUG",
        },
      ],
    },
    {
      title: "2021.09.15",
      data: [
        {
          test: "1、增加点击屏幕特效",
        },
        {
          test:
            "模型表cfg_model_info.xls 添加特效ID:5011和5012 不想要点击屏幕特效可以把这2个ID删除掉",
        },
        {
          test: "2、增加让怪物再爆一次",
        },
        {
          test: "格式：MonItems 次数(最大20次)",
        },
        {
          test: "例子：",
        },
        {
          test: "QFunction-0.txt",
        },
        {
          test: "[@KillMon]",
        },
        {
          test: "#IF",
        },
        {
          test: "#act",
        },
        {
          test: "MonItems 1",
        },
        {
          test: "SENDMSG 6 当前死亡的怪物再爆一次",
        },
        {
          test: "3、优化自定义属性卡的问题",
        },
        {
          test: "4、优化套装属性重复触发造成M2崩溃问题",
        },
        {
          test: "5、增加端剑甲内观缩放功能",
        },
        {
          test:
            "表：cfg_game_data.xls 增加字段：staticSacle 格式：移动端剑甲内观缩放（默认1.44）#PC端剑甲内观缩放（默认1.0）",
        },
        {
          test:
            "6、增加怪物出生点守护范围 怪物表：cfg_monster.xls    Y列字段：GuardRange  设置守护范围",
        },
        {
          test: "7、新增英雄 H.SetSuckDamage伤害吸收命令",
        },
        {
          test: "8、新增英雄无极真气CD时间设置, M2-英雄设置-技能合击设置",
        },
        {
          test:
            "9、新增自动穿戴只穿背包里最优先的装备,一个装备位置只提示一次",
        },
        {
          test: "10、修复护体神盾开启提示文字信息",
        },
        {
          test: "11、修复人形怪不释放开天斩、无视隐身术问题",
        },
        {
          test:
            "12、修复斗笠数据库设置：Anicount 0戴上后显示头盔的内观无效问题",
        },
        {
          test:
            "13、修复客户端常量 $STM(HP)  $STM(MP) ,$STM(X)  $STM(Y) 显示不实时刷新问题",
        },
        {
          test: "14、修复6个合击技能,技能触发不支持问题",
        },
        {
          test: "15、修复PC 端Tips 备注上下排版太密了问题",
        },
        {
          test: "16、修复Checkmagic命令失效问题",
        },
        {
          test: "17、修复小退后无法编辑行会公告问题",
        },
        {
          test: "18、修复自定义按钮110 任务栏面板PC端无效问题",
        },
        {
          test: "19、修复H.USEBONUSPOINT面板不实时刷新问题",
        },
        {
          test: "20、修复半月弯刀打不到选中的目标怪物问题",
        },
        {
          test: "21、修复浑水摸鱼显示行会名字问题",
        },
        {
          test: "22、修复装备加星物品不自动修理问题",
        },
        {
          test:
            "23、新增CONFERTITLE 称号名称(也就是在物品数据库增加的那个称号物品名称) 是否设置为当前称号(1=设置为当前称号)",
        },
      ],
    },
    {
      title: "2021.08.30",
      data: [
        {
          test: "1、增加设置和检测人物当前权限",
        },
        {
          test: "检测格式：CHECKMISSION 操作符(< > = ? ) 权限(0~10) ",
        },
        {
          test: "设置格式：CHANGEPERMISSION 设置权限(0~10)",
        },
        {
          test: "//;例子",
        },
        {
          test: "[@设置人物权限10级]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "CHANGEPERMISSION 10",
        },
        {
          test: "SENDMSG 6 你设置了当前人物权限10级",
        },
        {
          test: "[@检测人物权限]",
        },
        {
          test: "#IF",
        },
        {
          test: "CHECKMISSION > 5",
        },
        {
          test: "#ACT",
        },
        {
          test: "SENDMSG 6 你当前权限大于5",
        },
        {
          test: "2、增加获取指定玩家名称英雄职业",
        },
        {
          test: "//;格式：GetPlayHeroJob 玩家名称 存入变量",
        },
        {
          test: "//;例子",
        },
        {
          test: "[@获取指定玩家英雄职业]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "GetPlayHeroJob 张三 N1",
        },
        {
          test: "SENDMSG 6 张三的英雄职业为:<$STR(N1)>",
        },
        {
          test: "3、增加获取指定英雄主人的名字",
        },
        {
          test: "//;格式：GetHeroMasterName 英雄名称 存入变量",
        },
        {
          test: "//;例子",
        },
        {
          test: "[@获取英雄主人名称]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "GetHeroMasterName 李四 S1",
        },
        {
          test: "SendMsg 6 英雄李四的主人名称为:<$STR(S1)>",
        },
        {
          test: "4、增加绘制主界面的魔法球血球效果",
        },
        {
          test:
            "//;格式：PLAYMAGICBALLEFFECT 参数1 参数2 参数3 参数4 参数5 参数6 参数7 参数8 参数9",
        },
        {
          test:
            "参数1：图片开始序号 图片路径：res\\private\\ 移动端：mhp_ui  PC端：mhp_ui_win32 (图片前缀名字：fhp_:HP整圆形 hp_：HP半圆形 mp_：MP半圆形) ",
        },
        {
          test: "参数2：播放张数",
        },
        {
          test: "参数3：播放速度(毫秒)",
        },
        {
          test: "参数4：有效时间(秒 -1时永久有效)",
        },
        {
          test: "参数5：类型(0=HP 1=MP 2=FHP)",
        },
        {
          test: "参数6：绘制高度(0=完整绘制 1=按照HP或者MP的高度绘制)",
        },
        {
          test: "参数7：微调坐标X",
        },
        {
          test: "参数8：微调坐标Y",
        },
        {
          test:
            "参数9：显示缩放比例 (填写的数值除以100 如：50=0.5倍显示 110=1.1倍显示)",
        },
        {
          test: "//;例子",
        },
        {
          test: "//;QManage.txt",
        },
        {
          test: "[@Login]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "PLAYMAGICBALLEFFECT 0 30 200 -1 0 1 0 0 100",
        },
        {
          test: "PLAYMAGICBALLEFFECT 0 30 200 -1 1 1 0 0 100",
        },
        {
          test: "PLAYMAGICBALLEFFECT 0 30 200 -1 2 1 0 0 100",
        },
        {
          test: "5、扩展人物背包格子数量到126格",
        },
        {
          test: "说明：快捷栏6格也算在角色背包格子内",
        },
        {
          test: "大背包最多扩展到3页 (1页46格，2页86格，3页126格)",
        },
        {
          test: "背包格子数量达到47格或以上，自动显示第二个背包切页按钮",
        },
        {
          test: "背包格子数量达到87格或以上，自动显示第三个背包切页按钮",
        },
        {
          test: "当前背包格子数量常量：<$ADVBAGSIZE>",
        },
        {
          test: ";例子",
        },
        {
          test: "[@MAIN]",
        },
        {
          test: "#IF",
        },
        {
          test: "CHECKGAMEGOLD > 100",
        },
        {
          test: "#ACT",
        },
        {
          test: "EXTBAGOPENITEMCOUNT 50",
        },
        {
          test: "SENDMSG 6 你的背包格子扩展到<$ADVBAGSIZE>格",
        },
        {
          test: "6、修复合击技能书需要职业提示错误的问题",
        },
        {
          test: "7、修复官方武器怒斩外观显示异常的问题",
        },
        {
          test:
            "8、修复M2-功能设置-其他设置-持续麻痹时间控制，冷却时间修改后，重启M2不保存的问题。",
        },
        {
          test:
            "9、修复准确<$HIT> 武器攻速<$HITSPD> 武器幸运<$WEAPONLUCKY> 常量失效的问题",
        },
        {
          test: "10、修复开启行会战 英雄杀人，主人会红名武器会诅咒的问题",
        },
        {
          test:
            "11、修复邮件系统给与叠加物品的种类超过背包格子存放的格数领取后小退，部分叠加物品会消失的问题",
        },
        {
          test:
            "12、修复StdMode = 16，斗笠类装备 Source=0时显示神秘人无效的问题和Source=1时基础属性多一条 强度+1的问题",
        },
        {
          test: "13、修复给英雄称号后，收回在重新召唤称号不在了的问题。",
        },
        {
          test:
            "14、修复CalcPer命令取数值百分比，数值超过2千1百万，取数值不准的问题",
        },
        {
          test: "15、修复自定义OK框无法获取10个以上中文",
        },
        {
          test: "16、商铺货币尾数显示修改为显示小数点后2位",
        },
        {
          test: "17、修复邀请入会按钮",
        },
        {
          test: "18、修复M2/升级武器/武器升级失败不破碎无法勾选问题",
        },
        {
          test: "19、增加人物显示一个放大的虚影",
        },
        {
          test: "格式：SHOWPHANTOM 透明度值越小越透明(0~255) 显示时间(秒)",
        },
        {
          test: "例子：",
        },
        {
          test: "[@MAIN]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "SHOWPHANTOM 255 10",
        },
        {
          test: "SENDMSG 6 人物放大透明度255,10秒后恢复正常",
        },
        {
          test: "20、修复英雄客户端OPENHYPERLINK 7打开背包命令失效问题",
        },
        {
          test:
            "21、修复脚本命令释放技能 releasemagicex 开天斩 有特效没伤害问题",
        },
        {
          test: "22、修复自定义图片Img show=1 ,show=3参数失效问题",
        },
        {
          test: "23、修复英雄的元素属性,穿戴装备,面板不实时刷新问题",
        },
        {
          test: "24、修复@PickUpItemEx给与绑定后背包不自动叠加问题",
        },
        {
          test: "例子:",
        },
        {
          test: "[@PickUpItemEx]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "SetItemState -1 0 1",
        },
        {
          test: "UpDateBoxItem -1",
        },
        {
          test: "25、修复地图参数DECMONEY金币不够扣不回城问题",
        },
        {
          test:
            "26、修复魔法盾防御太高问题M2设置-技能魔法-魔法盾防御力倍数支持负数调整 最低到-300",
        },
        {
          test: "27、修复技能触发 MagSelfFunc   开天斩 逐日剑法 不支持问题",
        },
        {
          test: "28、修复PC端官方界面按钮取消后,tips还会显示问题",
        },
        {
          test: "29、修复英雄佩戴复活戒指无效问题",
        },
        {
          test: "30、修复宝石镶嵌宝石显示的位置错误问题",
        },
        {
          test: "31、修复开启时装外显 排行榜显示的装备外观了栏没有裸模问题",
        },
        {
          test: "32、修复M2-技能狮子吼 允许麻痹宝宝勾选不保存问题",
        },
        {
          test: "33、修复检测英雄技能等级H.GetMagicLevel 命令无效问题",
        },
        {
          test: "33、修复被毒后护身戒指蓝血没掉完,掉红血问题",
        },
        {
          test: "34、增加英雄自动穿装备引导提示功能",
        },
        {
          test: "35、增加私人自定义数字型变量支持加减乘除等于 + - * / = 算法",
        },
        {
          test: "36、修复挂机治愈术给怪物加血问题",
        },
        {
          test: "37、增加禁止编辑行会公告功能",
        },
        {
          test: "例子：",
        },
        {
          test: "QFunction-0.txt",
        },
        {
          test: "[@UpdateGuildNotice]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "STOP",
        },
        {
          test: "38、增加自定义属性前面显示图片和特效功能",
        },
        {
          test: "配置说明：",
        },
        {
          test: "在cfg_custpro_caption.xls C列tubiao字段配置",
        },
        {
          test: "格式:",
        },
        {
          test: "1=PC图标#移动图标 ",
        },
        {
          test: "2=PC特效ID#移动特效ID",
        },
        {
          test: "39、增加附加伤害效果RangeHarm",
        },
        {
          test:
            "格式:RangeHarm 参数1 参数2 参数3 参数4 参数5 参数6 参数7 参数8 参数9",
        },
        {
          test: "参数1：X坐标",
        },
        {
          test: "参数2：Y坐标",
        },
        {
          test: "参数3：范围",
        },
        {
          test: "参数4：伤害值(计算防御)",
        },
        {
          test:
            "参数5：附加效果 0=无,1=击退,2=冻结,3=麻痹,4=吸血,5=吸蓝,6真实伤害数值,7蛛网效果,8红毒,9绿毒,10定身,11防禁锢,12最大hp百分比真实伤害,13当前hp百分比真实伤害",
        },
        {
          test:
            "参数6：附加属性值 参数5= 1;击退距离、2;冻结时间、3;麻痹时间、4;吸血值、5;吸蓝值、6;真实伤害值、7;蛛网时间、8;红毒时间、9;绿毒时间、10;定身时间(定身时间单位是毫秒)、11;防禁锢时间(秒) ",
        },
        {
          test: "12;最大hp百分比真实伤害的值 13;当前hp百分比真实伤害的值",
        },
        {
          test:
            "参数7：是否检查防冻结/麻痹/石化/冰冻/蛛网/红毒/绿毒属性（0=直接设置状态;1=检查后设置状态)",
        },
        {
          test: "参数8：目标(0或空=所有目标; 1=仅人物;2=仅怪物)",
        },
        {
          test: "参数9：特效ID，目标身上的特效",
        },
        {
          test: "例子:",
        },
        {
          test: "[@Attack]",
        },
        {
          test: "#IF",
        },
        {
          test: "#ACT",
        },
        {
          test: "RangeHarm <$X> <$Y> 12 3000 1 2 0 0 56",
        },
        {
          test: "SENDMSG 6 当前屏幕内怪物自动击退3格",
        },
      ],
    },
    {
      title: "2021.06.19",
      data: [
        {
          test: "01、增加怪物离开设定的范围会到出生点功能",
        },
        {
          test:
            "02、增加自定义渠道来源方式常量(自定义字符串自己和渠道方协商)",
        },
        {
          test: "03、增加客户端敏感字过滤",
        },
        {
          test: "04、增加英雄全套系统",
        },
        {
          test: "05、增加英雄状态切换配置",
        },
        {
          test: "06、增加正式服物品日志记录功能(脚本操作类的)",
        },
        {
          test: "07、增加内挂备注说明功能cfg_setup.xls N列增加字段：Tips",
        },
        {
          test: "08、增加地图参数禁止召唤英雄NORECALLHERO",
        },
        {
          test:
            "09、增加任务显示排序功能，任务表G列字段：order 数字越小排序最靠前",
        },
        {
          test:
            "10、增加任务表特效根据当前状态显示，如：接任务 任务进行中 完成任务 分别显示特效 ",
        },
        {
          test: "11、修改在角色装备面板添加特效删除功能-1为删除",
        },
        {
          test:
            "12、增加拍卖行分类设置 设置表：cfg_auction_type.xls 参考表下载",
        },
        {
          test: "13、增加英雄使用称号触发",
        },
        {
          test: "14、修改聚灵珠使用触发功能",
        },
        {
          test: "15、增加记录玩家操作NPC日志",
        },
        {
          test: "16、修复拍卖行不能单独设置一口价的问题。",
        },
        {
          test: "17、修复人物选择时装外显时，排行榜上显示的问题。",
        },
        {
          test: "18、增加护身增加蓝耗控制，M2-功能设置-其他设置-增加蓝耗比例",
        },
        {
          test: "19、修复毒，符类穿戴位置，能佩戴在右手镯上的问题。",
        },
        {
          test:
            "20、修复在施毒术有几率毒不上人物的情况下，宝宝会攻击人物，主人名字不变灰的问题。",
        },
        {
          test: "21、修复月灵攻击人物不显示飘血的问题",
        },
        {
          test: "22、修复移动端技能描述Tips不显示的问题",
        },
        {
          test: "23、修复叠加物品拆分后丢地上在拾取，没有触发提示。",
        },
        {
          test: "24、修复顶戴花翎闪的问题",
        },
        {
          test: "25、修复自定义UI导航栏，编辑好的任务界面，缩进后会复位",
        },
        {
          test:
            "26、增加货币选择，cfg_item表里货币分类，Shape项填写 99摆摊+拍卖行货币显示",
        },
        {
          test:
            "27、增加拍卖行竞拍价和一口价最低价格和最高价格设置，M2-选项-功能设置-个人商店",
        },
        {
          test: "28、修复祈祷特殊套不生效，宝宝不叛变的问题。",
        },
        {
          test:
            "29、增加cfg_att_score.xls表，扩展到90项属性，修复部分属性无效的问题。",
        },
        {
          test: "30、增加在人物身上播放魔法效果",
        },
        {
          test: "31、增加文本通区功能",
        },
        {
          test: "32、新增引擎M2中毒时间调整",
        },
        {
          test: "33、修复镶嵌宝石宝石图片跟文字重叠问题",
        },
        {
          test: "34、修改关联刷新自定义OK框接口:UpDateBoxItem 0~99",
        },
        {
          test: "35、修复PC端战士1级显示蓝血问题",
        },
        {
          test: "36、新增装备在背包的特效和内观的特效缩放功能",
        },
        {
          test: "37、修复四级盾防御小于三级的问题",
        },
        {
          test: "38、新增内挂新增自动穿装备选项",
        },
        {
          test: "39、新增装备表和道具表单件装备设置，是否自动穿戴装备提示",
        },
        {
          test: "40、修复泡点时角色属性框滑动后弹回问题",
        },
        {
          test: "41、修改ItemShow货币显示，10000万修改显示为1亿",
        },
        {
          test: "42、修复人形怪名字显示屏蔽数字",
        },
        {
          test: "43、增加PC端背包，角色，技能，指向ID",
        },
        {
          test: "44、新增商城物品添加绑定功能",
        },
        {
          test: "45、增加数字转换图片功能支持常量和变量",
        },
        {
          test: "46、修复M2设置暴击威力倍数重启复原问题",
        },
        {
          test: "47、增加物品备注显示顶部、底部备注功能",
        },
        {
          test: "48、增加小地图自动寻路终点坐标常量",
        },
        {
          test: "49、增加加IncFileList命令",
        },
        {
          test:
            "50、增加是否屏蔽技能信息提示功能，M2--功能设置--启用技能文本提示",
        },
        {
          test: "51、新增指定转生等级及指定职业，穿戴或使用物品条件设置。",
        },
        {
          test: "52、新增HUMANHP 参数3 支持调用图片显示血量",
        },
        {
          test: "53、修复拍卖行搜索功能失效问题",
        },
        {
          test: "54、修复内挂设置自动召唤月灵会一直不停召唤问题",
        },
        {
          test: "55、修复内挂设置自动无极气会一直释放无极气问题",
        },
        {
          test: "56、修复禁止修复装备还是会修复的问题",
        },
        {
          test:
            "57、修复血球龙头图片在上层会挡住快捷栏，导致快捷栏不能使用问题",
        },
        {
          test: "58、修复M2设置，VIP上架数量 重启M2不保存问题",
        },
        {
          test: "59、修复AddTextList，DelTextList第三个参数不支持问题",
        },
        {
          test:
            "60、修复招的人形怪宝宝，不显示主人名字 ，传送时人形怪不会跟着传送 ",
        },
        {
          test:
            "61、修复人形怪宝宝不会主动攻击怪物 ，人形怪会攻击人形怪的宝宝问题",
        },
        {
          test: "62、修复 Race 82毒蜘蛛 84蝎子 85 食人花 不显示挖肉图标问题",
        },
        {
          test:
            "63、增加物品备注支持文字调整显示位置功能和增加图片显示，特效显示功能",
        },
      ],
    },
    {
      title: "2021.04.27",
      data: [
        {
          test: "01、增加改变人物自己状态",
        },
        {
          test: "02、取消变量DIV4舍5入算法",
        },
        {
          test: "03、增加接口修改技能威力和技能防御",
        },
        {
          test: "04、增加面板显示角色内观部件位",
        },
        {
          test: "05、增加使用脚本命令解毒",
        },
        {
          test: "06、增加新任务表换行功能 格式：<br>",
        },
        {
          test: "07、增加客户端设置单性别配置",
        },
        {
          test: "08、增加套装触发功能",
        },
        {
          test: "09、修改打开NPC和寻路打开NPC功能",
        },
        {
          test: "10、增加内挂隐藏顶戴花铃功能",
        },
        {
          test: "11、修复套装百分比不叠加自定义属性问题",
        },
        {
          test: "12、增加修改装内观功能",
        },
        {
          test: "13、增加检测地图相同怪物数量",
        },
        {
          test: "14、修复隔位刺杀不能释放开天斩和逐日剑法的问题",
        },
        {
          test:
            "15、修复自定义ui时装界面查看玩家界面的和自己界面不同步的问题",
        },
        {
          test: "16、增加人物变色功能",
        },
        {
          test: "17、修复新手引导任务面板收起状态打不开面板问题",
        },
        {
          test: "18、增加微信公众号验证码全套功能",
        },
        {
          test: "19、增加拉起QQ群，拉起QQ加好友，拉起QQ，拉起微信功能",
        },
        {
          test:
            "20、增加cfg_colour_style.xls和cfg_colour_style-win32.xls表中的ID超过255的支持描边，字体大小，自定义颜色等功能",
        },
        {
          test: "21、增加商城支持多货币扣除功能",
        },
        {
          test: "22、增加多货币关联使用功能",
        },
        {
          test: "23、增加圆形进度条功能",
        },
        {
          test: "24、修复刀魂系统 进度框显示的问题",
        },
        {
          test: "25、增加拍卖行搜索功能",
        },
        {
          test: "26、扩展附加属性支持到21亿",
        },
        {
          test:
            "27、修改行会人数规则，不读取GAME_DATA表里面的行会字段，设置行会初始人数入口：参数设置-游戏选项1-行会人数限制",
        },
        {
          test:
            "28、增加通过玩家名字获取行会名称，获取指定行会人数，设置行会总人数功能",
        },
        {
          test: "29、增加CTRL+F4直接刷新模型表读配置",
        },
        {
          test: "30、修复编辑角色面板查看到其他玩家不同步问题",
        },
        {
          test: "31、编组地图传送，增加传送范围参数设置",
        },
        {
          test:
            "32、修复打孔镶嵌宝石，Shape为255时，镶嵌后DB的Looks素材图和宝石图重叠的问题，以及素材缩小的问题。",
        },
        {
          test: "33、检测当前被攻击者身上状态",
        },
        {
          test:
            "34、修复使用修复神水后，装备的属性不能恢复，需要小腿或者放到背包里刷新的问题",
        },
        {
          test: "35、修复加星装备在仓库里不显示加星数量，其它地方显示问题",
        },
        {
          test:
            "36、新增加商铺去掉原价功能(商铺表格第4列填0或空，则不显示原价)",
        },
        {
          test: "37、修复同样持久极品装备出售价格不对问题",
        },
        {
          test: "38、增加内挂高帧率模式开关功能",
        },
        {
          test:
            "39、新扩展客户端自定义资源路径dev为你的所有自定义资源，方便打包版本资源",
        },
        {
          test: "40、增加客户端支持多版本登录",
        },
      ],
    },
    {
      title: "2021.04.01",
      data: [
        {
          test: "01、修改打开面板功能参数设置",
        },
        {
          test: "02、增加怪物表W列字段:Through单独设置可以穿怪",
        },
        {
          test: "03、增加U变量和T变量支持到999",
        },
        {
          test: "04、增加拾取精灵不可攻击引怪",
        },
        {
          test: "05、增加拾取精灵捡取动画",
        },
        {
          test: "06、增加地图参数人物可以走路穿人穿怪",
        },
        {
          test: "07、增加新手引导支持背包唯一ID引导和角色面板装备位置引导",
        },
        {
          test: "08、增加货币改变触发",
        },
        {
          test:
            "09、增加移动端小地图大小自由编辑和位置调整偏移 设置入口:cfg_game_data.xls 字段:MiniMap",
        },
        {
          test: "10、增加刺杀剑术生效格子调整",
        },
        {
          test: "11、取消逐日剑法2段伤害机制",
        },
        {
          test: "13、增加获取技能等级功能",
        },
        {
          test: "14、增加时装外观自动隐藏人物发型",
        },
        {
          test: "15、修复获取变量和传递变量功能",
        },
        {
          test: "16、修复增加人物属性减少不生效问题",
        },
        {
          test: "17、修复拉起充值无效问题",
        },
        {
          test: "18、增加佩戴引导按照分类提示按钮",
        },
        {
          test: "19、修复部分多级脚本不生效问题",
        },
      ],
    },
    {
      title: "2021.03.27",
      data: [
        {
          test: "01、增加拾取小精灵功能",
        },
        {
          test: "02、增加清理私人和全局自定义变量清理",
        },
        {
          test: "03、增加修改衣服和武器外观特效",
        },
        {
          test: "04、增加屏幕播放特效",
        },
        {
          test: "05、增加读写文本配置项",
        },
        {
          test: "06、增加准星物品类型StdMode=47",
        },
        {
          test: "07、修复部分多级脚本失效问题",
        },
        {
          test:
            "08、增加复活戒指死亡下线是否立即可以复活选项 设置入口:功能设置-其他设置",
        },
        {
          test: "09、增加给予玩家一个新的物品直接到指定位置不经过背包",
        },
        {
          test: "10、扩展自定义OK框数量支持到0~99位置",
        },
        {
          test: "11、增加转生增加属性点功能",
        },
        {
          test: "12、增加打开OK对话框功能",
        },
        {
          test: "13、增加套装备注,鼠标单独放到单个物品单个提示",
        },
        {
          test: "14、修复多级脚本不支持变量问题",
        },
        {
          test: "15、修改装备名称长度支持到32个字符",
        },
        {
          test: "16、增加自定义人物面板按钮",
        },
        {
          test: "17、修复背包满了买商铺物品会消失问题",
        },
        {
          test: "18、修复首饰盒限时物品显示问题",
        },
        {
          test:
            "19、修复改变人物模式,隐身,冰冻.禁锢.禁止攻击.蛛网.吸血.吸蓝等有问题的功能",
        },
        {
          test: "20、增加护身状态显示蓝血功能 设置入口：功能设置-其他设置",
        },
        {
          test: "21、增加用脚本命令释放技能",
        },
        {
          test: "22、增加聊天窗口信息前缀设置",
        },
        {
          test: "23、修复聚灵珠物品tips显示长度自动扩展",
        },
        {
          test: "24、修复调整元素命令不支持时间问题",
        },
        {
          test:
            "25、增加刷怪模式切换 按服务器启动时间计算,和按怪物死亡时间计算",
        },
        {
          test: "26、修复人物死亡立即复活后声音重复播放问题",
        },
        {
          test: "27、增加和修改任务系统功能 ",
        },
        {
          test: "28、增加一键拾取按钮脚本功能",
        },
        {
          test: "29、增加自动寻路打开指定NPC的面板",
        },
        {
          test: "30、修复技能音效不分男女问题",
        },
        {
          test: "31、增加移动端支持TIPS备注显示",
        },
        {
          test: "32、增加脚本设置防秒杀功能 ",
        },
        {
          test:
            "33、增加怪物Race=112 U列=射程范围 一般用来做弓箭手射程范围.为空默认为12格",
        },
        {
          test: "34、增加自定义进度条刀魂系统",
        },
        {
          test: "35、修复一键回收包裹物品支持自己输入指定数量",
        },
      ],
    },
    {
      title: "2021.03.02",
      data: [
        {
          test: "01、新增改变当前人物模式功能",
        },
        {
          test:
            "02、新增按钮红点功能 图片设置入口:cfg_game_data.xls 字段:Redtips 界面红点提示(PC端|移动端)",
        },
        {
          test: "03、修复清理尸体怪物名称没有清理掉问题",
        },
        {
          test: "04、修复魔法攻击最大幸运触发伤害计算不对问题",
        },
        {
          test: "05、增加通过物品唯一ID获取物品名称",
        },
        {
          test:
            "06、增加聚集类型物品满了红点提示功能 图片设置入口:cfg_game_data.xls 字段:prompt 背包满物品提示红点(PC端#X坐标#Y坐标#缩放比例|移动端#X坐标#Y坐标#缩放比例)",
        },
        {
          test: "07、修复人物回城之后，宝宝无敌问题",
        },
        {
          test: "08、修复拍卖行职业筛选问题",
        },
        {
          test: "09、修复人物戴上护身戒指之后被攻击掉血显示红字 -0 的问题",
        },
        {
          test: "10、修复行会模式任然可以攻击到本行会的宝宝",
        },
        {
          test: "11、修复攻击带护身戒指的玩家，攻击者名字不变灰色的问题",
        },
        {
          test: "12、修复人物攻击宝宝名字不变灰的问题",
        },
        {
          test: "13、修复GOTOLABEL 触发问题",
        },
        {
          test: "14、修复烈火剑法技能伤害变高问题",
        },
        {
          test: "15、修复多级脚本触发问题。",
        },
        {
          test: "16、修复ChangeHumAbility 增加的属性附带百分比加成问题",
        },
        {
          test: "17、修复组队邀请页面等级显示错误问题",
        },
        {
          test: "18、修改善恶模式，可以攻击灰名，和敌对行会功能",
        },
        {
          test:
            "20、增加装备掉落和制作极品机率控制 设置如何:选项-物品装备-极品机率",
        },
        {
          test:
            "21、增加装备掉落和制造元素控制 设置如何:选项-物品装备-新增属性",
        },
        {
          test: "22、修复匹配列表关键字问题",
        },
        {
          test: "23、增加修改行会公告触发",
        },
        {
          test: "24、修复部分GM失效的问题",
        },
        {
          test: "25、增加宝宝最大血量常量",
        },
        {
          test: "26、增加修改宝宝最大血量功能",
        },
        {
          test: "27、增加剔除离线挂机功能",
        },
        {
          test:
            "28、修复有两个玩家名字相同的玩家，改其中一个玩家名字，另一个玩家的名字也会被改掉",
        },
        {
          test: "29、修复战士技能不带暴击问题",
        },
        {
          test: "30、M2新增加载沙巴克配置功能",
        },
        {
          test: "31、M2新增加载怪物爆率功能",
        },
        {
          test: "32、新增数据库NEED字段使用物品条件设置",
        },
        {
          test: "33、新增复制文件功能",
        },
        {
          test: "34、新增内挂摇杆是否取消攻击功能",
        },
        {
          test: "35、新增脚本死循环设置次数 设置入口:参数设置-游戏选项[1]",
        },
        {
          test: "36、新增打孔镶嵌宝石功能",
        },
        {
          test: "37、修复地图参数禁止使用技能，自动挂机会一直尝试释放问题",
        },
        {
          test: "38、增加宝宝攻击触发",
        },
        {
          test: "39、增加宝宝攻击前触发",
        },
        {
          test: "40、增加靴子和腰带负重设置Anicount字段",
        },
        {
          test: "41、增加使用聚灵珠Stop中断使用功能",
        },
      ],
    },
    {
      title: "2021.01.26",
      data: [
        {
          test:
            "01、增加摆摊默认名称设置开启入口:[功能设置-客户端设置]默认名称设置:cfg_game_data.xls StallName= 摆摊默认名称    ",
        },
        {
          test: "02、修改挂机状态捡取物品功能,可以由玩家和GM自己去设置",
        },
        {
          test: "03、增加摆摊状态装备比较功能",
        },
        {
          test: "04、增加升级等级限制和经验控制[参数设置-升级经验]",
        },
        {
          test: "05、修复排行榜查默认显示为时装问题",
        },
        {
          test:
            "06、增加经验提示方式开关,和经验坐标调整功能 [功能设置-客户端设置-经验提示在聊天窗口] 在屏幕提示坐标设置参数:cfg_game_data.xls ",
        },
        {
          test: "07、修复摆摊物品可以被回收问题.",
        },
        {
          test: "08、复交易状态物品可以被回收问题",
        },
        {
          test: "09、增加人物防止被秒杀功能 [参数设置-PK控制]",
        },
        {
          test: "10、扩展删除称号,支持多个同时删除",
        },
        {
          test: "11、增加删除全部称号功能",
        },
        {
          test: "12、修改调整宝宝攻击人物的威力倍率为百分比",
        },
        {
          test: "13、修复PC端平砍接野蛮冲撞问题",
        },
        {
          test:
            "14、增加客户端聊天支持发送物品和表情,切换私聊目标,发送当前位置,等等",
        },
        {
          test: "15、修复人物带斗笠,离开视野看不到问题",
        },
        {
          test: "16、增加模拟器常量<$SIMULATOR> 0=不是 1=模拟器",
        },
        {
          test: "17、修复邮件背包满了,一下给多件物品消失问题",
        },
        {
          test: "18、增加火龙神怪物攻击方式Race=115 RaceImg=83 Appr=800",
        },
        {
          test: "19、增加检测RANDOMEX 随机数(子) 随机数(母)",
        },
        {
          test: "20、增加移动端复制功能(手机端和模拟器中才生效)",
        },
        {
          test:
            "21、诱惑之光召唤的宝宝判断设置入口:功能设置-技能魔法-法师技能-诱惑之光-叛变时间设置 默认100%=2个小时",
        },
        {
          test:
            "22、增加道士技能隐身术,集体隐身术的时间控制[功能设置-技能魔法]",
        },
        {
          test: "23、增加法师技能火墙的威力设置",
        },
        {
          test: "24、修复CHANGEMOBABILITY支持最大值21亿",
        },
        {
          test:
            "25、增加客户端静默下载 路径:stab/data_config/downloadpack.json 最多同时静默下载2个,注意:最后一个文件请不要加,逗号否则进不去游戏",
        },
        {
          test: "26、增加封加速参数设置 [参数设置-游戏速度-防加速外挂设置]",
        },
        {
          test: "27、修复宝宝仇恨距离问题",
        },
        {
          test: "28、增加拍卖行购买手续费修改功能[参数设置-费用价格]",
        },
        {
          test: "29、新增获得宝宝触发功能",
        },
        {
          test: "30、新增修改宝宝攻击速度和移动速度功能",
        },
        {
          test: "31、新增私聊/直接发送给角色 比如:/刘德华 可以直接发送到对方",
        },
      ],
    },
    {
      title: "2021.01.11",
      data: [
        {
          test: "01、修复背包满了购买物品发送邮件问题",
        },
        {
          test: "02、修复安全区禁止穿过NPC,禁止穿过怪物问题",
        },
        {
          test: "03、增加复活时间间隔设置,复活后禁止立即传送",
        },
        {
          test: "04、优化PC端画质问题",
        },
        {
          test: "05、增加PC端输入状态回车确定功能",
        },
        {
          test: "06、增加是否开启宝宝安全区互相打架功能",
        },
        {
          test: "07、增加复活间隔设置,复活起来传送时间设置",
        },
        {
          test:
            "08、增加打怪减少固定血量 怪物表字段:Attribute 3#2#500 2=代表属性表里面的MP 500= 代表每次攻击最大掉血",
        },
        {
          test: "09、新增摆摊名字常量 <$STALLNAME>",
        },
        {
          test: "10、修复四级技能小退不生效问题",
        },
        {
          test: "11、增加无极真气每级威力递增",
        },
        {
          test:
            "12、增加物品唯一ID自动放入自定义OK框 BAGITEMMAKEINDEX 物品唯一ID OK框编号(0~7)",
        },
        {
          test: "13、增加NPC气泡功能开关 设置入口:功能设置-客户端设置",
        },
        {
          test: "14、增加NPC显示名字开关 设置入口:功能设置-客户端设置",
        },
        {
          test: "15、增加攻击前触发,和攻击前伤害控制. ",
        },
        {
          test:
            "16、增加挂机状态,治疗术只可以给宝宝和人物加血,不可以给怪物加血",
        },
        {
          test: "17、修复每天第一登录没下线也触发问题",
        },
        {
          test: "18、修复隐身模式切换地图失效问题",
        },
        {
          test: "19、优化角色PK走位问题",
        },
        {
          test: "20、优化野蛮冲撞可以冲撞两个人",
        },
        {
          test: "21、增加麻痹状态禁止回城功能",
        },
        {
          test: "22、优化调用内挂按钮按照职业显示",
        },
        {
          test: "23、增加群体施毒术技能",
        },
      ],
    },
    {
      title: "2021.01.04",
      data: [
        {
          test: "01、增加自定义快捷键触发 新增表:data'\\c'fg_KeyFunc.xls",
        },
        {
          test: "02、增加刷怪物文本,支持怪物颜色,和刷新触发QFunction-0.tx",
        },
        {
          test: "03、增加PC端挂机快捷键Ctrl+Z",
        },
        {
          test: "04、修复怪物错位，无敌怪问题",
        },
        {
          test: "05、修复GM命令召唤属下立即消失问题。",
        },
        {
          test: "06、增加改变宝宝名字颜色按时间失效",
        },
        {
          test: "07、增加改变宝宝属性按时间失效",
        },
        {
          test: "08、修复开启宝箱31类型触发界面不显示问题。",
        },
        {
          test: "09、增加手动吃药解包功能",
        },
        {
          test: "10、增加聊天触发功能",
        },
      ],
    },
    {
      title: "引擎更新: 2020.12.28",
      data: [
        {
          test: "01、修复召唤宝宝出来消失的问题",
        },
        {
          test: "02、修复沙巴克攻沙时候人物名字没有刷新问题",
        },
        {
          test: "03、修复沙巴克复活点失效问题",
        },
        {
          test: "04、修复邮件小退失效问题",
        },
        {
          test:
            "05、修复油只能修复武器，不修复全身装备，修复后最大持久度减一。",
        },
        {
          test: "06、修复无极真气技能释放问题",
        },
        {
          test: "07、修复狮子吼麻痹状态攻击怪物麻痹失效问题",
        },
        {
          test: "08、修复人物发型1显示问题",
        },
        {
          test: "09、修复建立同名行会问题",
        },
        {
          test: "10、修复攻城名字颜色问题",
        },
        {
          test: "11、修复掉落提示坐标",
        },
        {
          test: "12、修复神兽配置多级数据导致的异常",
        },
        {
          test: "13、修复相同道具存仓库不合并问题",
        },
        {
          test: "14、修改内挂保护配置",
        },
        {
          test:
            "15、增加了任务结束触发：@MissEnd，N0变量存的是结束时的任务ID",
        },
        {
          test:
            "16、增加摆摊显示名称,怪物体力恢复,喝药基数,喝药速度设置 设置入口:(参数设置-游戏选项2)",
        },
        {
          test: "17、增加人物体力恢复",
        },
        {
          test: "18、增加摆摊支持多货币功能",
        },
        {
          test:
            "19、增加已修复沙巴克城墙，城门命令： REPAIRCASTLE 0 //修复城门，城墙等。 0 表示城堡编号。默认可不写、",
        },
        {
          test: "20、增加GiveStateItem支持叠加物品集合给予",
        },
        {
          test: "21、增加客户端数字转换图片功能",
        },
      ],
    },
    {
      title: "2020.12.14",
      data: [
        {
          test: "01、修复挂机状态会自动攻击自己宝宝",
        },
        {
          test: "02、修改商店成可视化商店",
        },
        {
          test: "03、修复恢复蓝量无效的问题 ",
        },
        {
          test: "04、修复任务一个BUG",
        },
        {
          test: "05、修复自定义属性bug，物品规则增加20，穿戴时不爆。",
        },
        {
          test: "06、修复多级检测玩家是否在线的",
        },
        {
          test: "07、stdmode=200, 生成的物品增加物品来源",
        },
        {
          test: "08、修改时装武器不区分性别",
        },
        {
          test: "09、增加装备对比, 自动穿戴层级好的装备",
        },
        {
          test: "10、增加时装首饰开启控件",
        },
        {
          test: "11、增加面对面交易状态常量<$DEALFTF>",
        },
        {
          test: "12、增加血量上限值修改，支持42亿",
        },
        {
          test: "13、增加增加行会成员退出行会后，入会的冷却时间。",
        },
        {
          test: "14、增加增加获取武器基础幸运值常量 $WEAPONLUCKY",
        },
        {
          test:
            "15、增加允许怪物不弯腰，吸血元素，万分比。充值接口，支持脚本触发，@ReCharge, N0 存放ProductId ",
        },
        {
          test:
            "16、增加人物掉落物品记录日志功能，人物死亡掉落物品列表保存到S0变量",
        },
        {
          test:
            "17、增加NPC脚本命令的物品日志记录 涉及命令： TAKE TAKEW GIVE 物品数据库 cfg_equip.xls cfg_item.xls 增加字段 AB列 支持是否记录标记",
        },
        {
          test: "18、拍卖增加vip区分, 增加展示时间",
        },
        {
          test: "19、增加怪物回血时间设置（cfg_monster.xls S列） ",
        },
        {
          test: "20、增加怪物名字颜色设置（cfg_monster.xls R列） ",
        },
        {
          test: "21、增加元宝可用绑元替代设置 ",
        },
        {
          test: "22、增加技能文本提示控制开关",
        },
        {
          test: "23、增加攻速调整，可以设置1点攻速减多少时间 ",
        },
        {
          test: "24、增加SETOFFTIMEREX 关闭定时器功能 ",
        },
        {
          test: "25、增加身上装备唯一ID的常量",
        },
      ],
    },
    {
      title: "cfg_model_info.xls(模型表)更新：",
      data: [
        {
          test: "01、增加39个斗笠外观",
        },
        {
          test: "02、更新道具icon",
        },
      ],
    },
    {
      title: "2020/12/07",
      data: [
        {
          test: "01、修复组队开启全图经验队友获取不到经验问题",
        },
        {
          test: "02、修复调整人物属性ChangeHumAbility支持到20个属性",
        },
        {
          test: "03、修复全局定时器无效问题",
        },
        {
          test: "04、修复装备修理持久不生效问题",
        },
        {
          test: "05、修复检测人物是否在线命令",
        },
        {
          test: "06、增加装备对比功能",
        },
        {
          test: "07、增加时装衣服武器和首饰系统",
        },
        {
          test: "08、增加面对面交易和非面对面交易选项-功能设置",
        },
        {
          test: "09、增加组队队长离开队伍, 队伍自动转移功能",
        },
        {
          test: "10、增加调整宝宝等级, 支持单个调整",
        },
        {
          test: "11、新增自定义按钮角色面板下层ID:3001",
        },
        {
          test: "12、增加面对面交易, 和非面对面交易选项 功能设置-其他设置",
        },
        {
          test: "13、增加几个沙巴克常量",
        },
        {
          test: "14、增加人物简装, 和怪物简装",
        },
        {
          test: "15、增加地图连接点左边范围进入地图",
        },
        {
          test: "16、增加传送地图, 到时间被传回原来地图",
        },
        {
          test: "17、增加给装备栏加特效",
        },
        {
          test:
            "18、增加怪物刷新时间显示, MonGen 最后一列，如果是1，就代表要显示时间",
        },
        {
          test:
            "19、增加属性表(cfg_att_score.xls)，34，吸血功能，71，每秒钟恢复血量属性",
        },
        {
          test:
            "20、精准爆率，如果使用RANDOM 关键字时，可以根据比重来随机生成一件之前只能1：1",
        },
        {
          test: "增加选择背包物品，进行打钩，支持逗号串联SelectBagItems",
        },
        {
          test:
            "增加cfg_game_data.xls表 增加字段AbilInfoEx，用来配置人物状态面板的扩展信息，格式：标题1#信息1|标题2#信息2，支持变量。",
        },
        {
          test:
            "增加删除背包物品DelItemByMakeIndex 参数1：物品唯一ID，允许逗号串联，一起删除",
        },
        {
          test:
            "LoopBagItems 参数1：回调函数@xxxx，参数2：存放物品的唯一id变量，参数3：存放物品名称的变量",
        },
      ],
    },
    {
      title: "客户端更新：版本",
      data: [
        {
          test: "前端 v2.3.7",
        },
        {
          test: "后端 20.11.30.1",
        },
      ],
    },
    {
      title: "客户端更新：修复",
      data: [
        {
          test: "1、EQUIPITEMS和BAGITEMS不使用缓存",
        },
        {
          test: "2、脚本UI在背景图大小改变时不刷新问题",
        },
        {
          test: "3、修复瞬回药检测异常问题",
        },
        {
          test: "4、公告文本类型回退",
        },
        {
          test: "5、修复强攻方向不对问题",
        },
      ],
    },
    {
      title: "客户端更新：优化",
      data: [
        {
          test: "1、NPC界面打开时背包位置调整，并增加可控背包在左在右",
        },
        {
          test: "2、显示时装按钮不改变内观",
        },
        {
          test: "3、勾选移动隔位刺杀不再触发攻杀",
        },
        {
          test: "4、PC端都使用平滑模式，老的走路模式等调好再上",
        },
        {
          test:
            "5、挂机优化，走路时如果目标不可穿根据情况忽略目标，增加躲避技能和走位",
        },
        {
          test: "6、强攻按钮大小调整",
        },
        {
          test: "7、PC端走砍优化",
        },
        {
          test: "8、挂机后会往上走一步问题",
        },
        {
          test: "9、新的技能ICON",
        },
        {
          test: "10、热更异常提醒具体文件",
        },
      ],
    },
    {
      title: "客户端更新：新功能",
      data: [
        {
          test: "1、账号系统完善",
        },
        {
          test: "2、角色装备支持自定义属性",
        },
        {
          test: "3、脚本UI 新增DBItemShow",
        },
        {
          test: "4、面对面交易功能",
        },
        {
          test: "5、道具tips支持扩展属性",
        },
        {
          test: "6、装备回收，背包根据服务器数据勾选",
        },
        {
          test: "7、装备下面下层挂节点3001",
        },
        {
          test: "8、人物/怪物简装",
        },
        {
          test: "9、通用输入框屏蔽回车",
        },
        {
          test: "10、装备自动使用",
        },
        {
          test: "11、道具快捷使用",
        },
        {
          test: "12、小地图支持传送点/NPC/怪物显示",
        },
        {
          test: "13、增加装备特效",
        },
        {
          test: "14、法师也可以技能接平砍",
        },
      ],
    },
    {
      title: "2020/11/30",
      data: [
        {
          test: "01、修复 全局定时器",
        },
        {
          test: "02、修复 加星命令等于会变成加号的问题",
        },
        {
          test: "03、修复 大仓库存放会少物品问题",
        },
        {
          test: "04、修复 自定义OK框叠加物品不刷新问题",
        },
        {
          test: "05、修改 永久增加人物属性功能",
        },
        {
          test: "06、增加 当前时间戳常量 <$UTCNOW8>",
        },
        {
          test: "07、增加 面巾独立位置 可以和斗笠一起佩戴",
        },
        {
          test: "08、增加 沙巴克升级武器 同一把武器设置升级最大次数",
        },
        {
          test: "09、增加 GM命令重新读取欢迎公告功能 @ReloadNotice",
        },
        {
          test: "10、增加 MAPMOVE支持范围传送",
        },
        {
          test: "11、增加 物品添加标记",
        },
        {
          test: "12、增加 变量传递功能",
        },
        {
          test: "13、增加 stop停止执行下面脚本命令",
        },
        {
          test: "14、增加 仿照个人定时器的全局定时器",
        },
        {
          test: "15、新增 cfg_game_data.xls表操作",
        },
      ],
    },
    {
      title: "客户端更新：版本",
      data: [
        {
          test: "前端 v2.3.6",
        },
        {
          test: "后端 20.11.30.1",
        },
      ],
    },
    {
      title: "客户端更新：修复",
      data: [
        {
          test: "1、特效下载成功不显示问题",
        },
      ],
    },
    {
      title: "客户端更新：优化",
      data: [
        {
          test:
            "1、脚本UI优化，支持差异化更新、分步加载层数控制、初始加载层数控制，体验更佳",
        },
        {
          test: "2、技能释放优化，去掉方向，由目标点计算出方向",
        },
        {
          test: "3、进游戏公告使用FColor",
        },
        {
          test: "4、脚本UI元素，输入框优化",
        },
        {
          test: "5、血量刷新性能优化",
        },
        {
          test: "6、切换地图关闭NPC面板",
        },
        {
          test: "7、面纱装备位置调整",
        },
        {
          test: "8、主界面资源替换",
        },
        {
          test:
            "9、商店 获取祝福罐类型的持久读取背包同类的数据；价格读取小数点后一位数",
        },
        {
          test: "10、尸体清理排除沙巴克城门和城墙",
        },
        {
          test: "11、排行榜类型修改",
        },
        {
          test: "12、小退处理",
        },
        {
          test: "13、增加服务器状态显示",
        },
        {
          test: "14、PC端NPC购买面板资源替换",
        },
        {
          test: "15、杂货店商店资源替换",
        },
        {
          test: "16、持久过低排除部分类型",
        },
      ],
    },
    {
      title: "客户端更新：新功能",
      data: [
        {
          test: "1、增加引擎闪屏",
        },
        {
          test: "2、脚本UI支持BAGITEMS",
        },
        {
          test: "3、脚本UI支持EQUIPITEMS",
        },
        {
          test: "4、头盔斗笠面纱内观特效",
        },
        {
          test: "5、小地图增加关闭按钮",
        },
        {
          test: "6、增加自动对比",
        },
        {
          test: "7、增加时装",
        },
        {
          test: "8、攻击和魔法增加默认CD，由gamedata控制",
        },
      ],
    },
    {
      title: "cfg_model_info.xls(模型表)更新：",
      data: [
        {
          test: "01、修复上一版发型问题(说明书提供更换发型脚本案例)",
        },
        {
          test: "02、修复上一版所有内观特效偏移问题",
        },
        {
          test: "03、增加传奇归来部分新衣服相关特效",
        },
        {
          test: "04、增加重装上阵6张小地图",
        },
        {
          test: "05、增加石原怪物攻击特效",
        },
        {
          test: "06、修改4489、3389、5589特效ID",
        },
        {
          test: "07、增加绿色箭头动画5004特效ID",
        },
      ],
    },
    {
      title: "2020/11/23",
      data: [
        {
          test: "01、修复被施毒者小退在上线施毒者目标消失问题",
        },
        {
          test: "02、修改传音筒最大只支持110个字符",
        },
        {
          test: "03、修复组队模式宝宝还会攻击队友问题",
        },
        {
          test: "05、修复道具绑定物品tips没有显示绑定信息",
        },
        {
          test: "06、修改刷新背包按物品ID顺序排列",
        },
        {
          test: "07、修复加好友对方列表看不到好友信息",
        },
        {
          test: "08、修复内挂自动使用技能治愈术",
        },
        {
          test: "09、修复复活触发功能",
        },
        {
          test: "10、修复挂机状态治疗术给怪物加血",
        },
        {
          test: "11、修复流星火雨释放",
        },
        {
          test: "12、修复疾光电影释放走位",
        },
        {
          test: "13、修复引擎速度调整选项",
        },
        {
          test: "14、修复人物鼠标放到名字上显示不到全部信息问题",
        },
        {
          test: "15、修改背包, 地面, 内观资源扩展补丁规则",
        },
        {
          test: "16、重做内挂保护功能",
        },
        {
          test: "17、扩展PC端F11技能设置按键",
        },
        {
          test: "18、增加NPC调整方向功能cfg_npclist.xls ",
        },
        {
          test: "19、增加人物在线改名系统",
        },
        {
          test: "20、增加邮件给绑定物品规则",
        },
        {
          test: "21、增加直接打开NPC大窗口功能",
        },
        {
          test: "22、增加首饰盒功能",
        },
        {
          test: "23、增加检查是否为沙巴克老大",
        },
        {
          test: "24、增加开启宝箱功能",
        },
        {
          test: "25、增加怪物死亡金币直接入背包功能(选项-怪物设置)",
        },
        {
          test: "26、增加怪物死亡设置爆到地面物品范围(选项-怪物设置)",
        },
        {
          test: "27、增加首饰盒显示与隐藏功能和是否掉持久(功能设置-其他设置)",
        },
        {
          test:
            "28、增加单件装备,和首饰盒死亡爆率单独控制功能(参数设置-死亡控制)",
        },
        {
          test: "29、增加任务页面显示与隐藏开关(功能设置-其他设置)",
        },
        {
          test: "30、增加排行榜功能(功能设置-其他设置)",
        },
        {
          test: "31、增加斗笠相关功能",
        },
        {
          test: "32、增加祝福罐、毒、符禁止被修复神水修复",
        },
        {
          test: "33、增加物品内观特效和背包特效挂载",
        },
        {
          test: "34、增加命令打开大仓库面板",
        },
      ],
    },
    {
      title: "客户端资源：更新",
      data: [
        {
          test: "01、修复发型ID问题(配合以前的脚本，男0，女1)",
        },
        {
          test: "02、修复默认发型9999问题",
        },
        {
          test: "03、修复金蛋、银蛋更换ID",
        },
        {
          test: "ID335 金蛋 更换 ID336",
        },
        {
          test: "ID336 银蛋 更换 ID337",
        },
        {
          test: "04、修复流星火雨施法问题",
        },
        {
          test: "05、修复电僵尸施法8方向问题",
        },
        {
          test: "06、修复牛魔法师配置问题",
        },
        {
          test: "07、修复ID 242富贵兽偏移问题",
        },
        {
          test: "08、修复38-79武器ID缺失预备攻击动作",
        },
        {
          test: "09、修复老比奇0.map地图安全区附近阻挡缺失问题",
        },
        {
          test: "10、重排181·196技能ID",
        },
        {
          test: "11、重新整理内观文件",
        },
        {
          test: "12、重新整理翅膀外观文件：1-83",
        },
        {
          test: "13、重新整理武器外观特效",
        },
        {
          test: "14、增加obj40、smtile20，lhsd.map关联",
        },
        {
          test: "15、增加圣兽1-3，月灵怪物",
        },
        {
          test: "16、增加部分怪物施法、攻击特效",
        },
        {
          test: "17、增加幽灵船(异界神舰)地图",
        },
        {
          test: "18、增加开启宝箱相关资源",
        },
        {
          test:
            "19、增加羊年、猴年、鸡年、狗年、猪年、鼠年、2020周年套装 , 衣服武器",
        },
        {
          test: "20、增加所有翅膀外观、内观特效",
        },
        {
          test: "21、增加所有武器、衣服内观、外观特效",
        },
      ],
    },
    {
      title: "客户端更新：修复",
      data: [
        {
          test: "1、NPC响应间隔",
        },
        {
          test: "2、转向间隔",
        },
        {
          test: "3、脚本组件：倒计时",
        },
        {
          test: "4、自动战斗下打不中问题",
        },
        {
          test: "5、治疗术治疗自己修复",
        },
        {
          test: "6、PC端隔位刺杀先检测是否有刺杀",
        },
        {
          test: "7、清理尸体后 复活不显示问题",
        },
      ],
    },
    {
      title: "客户端更新：优化",
      data: [
        {
          test: "1、道具Tips增加药品显示",
        },
        {
          test: "2、极品首饰盒一些逻辑修正",
        },
        {
          test: "3、任务栏、极品首饰盒开关",
        },
        {
          test: "4、宝箱优化",
        },
        {
          test: "5、去掉移动和PC端的商城和摆摊按钮",
        },
        {
          test: "6、增加一个默认内观偏移文件",
        },
        {
          test: "7、寻路优化",
        },
        {
          test: "8、添加道具特效相关",
        },
        {
          test: "9、技能释放表现优化",
        },
        {
          test: "10、脚本组件 特效增加播放次数",
        },
        {
          test: "11、调整边玩边下同时下载的文件数量",
        },
        {
          test: "12、清理尸体后 顶戴花翎也不显示",
        },
        {
          test: "13、可挖掘检测优化",
        },
        {
          test: "14、内观特效解析调整",
        },
        {
          test: "15、任务栏内容使用FColor",
        },
        {
          test: "16、脚本UI加载速度优化",
        },
      ],
    },
    {
      title: "客户端更新：新功能",
      data: [
        {
          test: "1、游戏调速和技能CD",
        },
        {
          test: "2、元变量支持Button",
        },
        {
          test: "3、加载页可由后台上传",
        },
      ],
    },
    {
      title: "2020/11/16",
      data: [
        {
          test: "01、修复 道士宝宝攻击人物伤害不对BUG",
        },
        {
          test: "02、修复 AddTextListEx写到空文本中,不能写入超过0行问题",
        },
        {
          test: "03、修复 组队模式可以攻击队友问题",
        },
        {
          test: "04、修复 组队模式地面物品不能被队友捡取问题",
        },
        {
          test: "05、修复 地图事件仍物品和捡武器背包多件才触发BUG",
        },
        {
          test: "06、修复 半月弯刀无效问题",
        },
        {
          test: "07、修复 怪物仇恨范围",
        },
        {
          test: "08、修复 自己有行会,查看没有行会的玩家显示自己行会BUG",
        },
        {
          test: "09、修复 物品光柱在建筑下面的问题",
        },
        {
          test:
            "10、修复 称号倒计时,切换面板时间重新计算和倒计时时间到了称号不消失问题",
        },
        {
          test: "11、修复 安全区不受控制选项无效问题",
        },
        {
          test: "12、修复 叠加物品提示持久过低BUG",
        },
        {
          test: "13、修复 背包负重满了,还可以继续买东西",
        },
        {
          test: "14、修复 移动端攻击时候不能野蛮问题",
        },
        {
          test: "15、修复 自定义采集功能",
        },
        {
          test: "16、增加 内挂战斗按职业显示选项-功能设置-其他设置",
        },
        {
          test:
            "17、增加 技能表cfg_skill_present.xls 字段:skillgensui 施法特效跟随人物移动",
        },
        {
          test: "18、增加 内挂移动端移动隔位刺杀功能",
        },
        {
          test: "19、增加 移动端夫妻模式",
        },
        {
          test: "20、增加 资源工具内观可视化调整坐标",
        },
        {
          test: "21、增加 浑水摸鱼神秘人功能",
        },
        {
          test: "22、增加 检查玩家是否加入行会命令",
        },
        {
          test: "23、增加 内挂物品使用备注",
        },
        {
          test: "24、增加 邮件系统",
        },
        {
          test: "25、增加 打开NPC打开大窗口",
        },
      ],
    },
    {
      title: "客户端更新：修复",
      data: [
        {
          test: "1、修复普攻快捷键问题",
        },
        {
          test: "2、施毒术颜色问题",
        },
      ],
    },
    {
      title: "客户端更新：优化",
      data: [
        {
          test: "1、自定义UI加载效率优化",
        },
        {
          test: "2、宝箱功能优化",
        },
        {
          test: "3、内挂吃药优化",
        },
        {
          test: "4、内观偏移优化和偏移数据读取",
        },
        {
          test: "5、背包界面调整",
        },
        {
          test: "6、人物面板放大",
        },
        {
          test: "7、PC端技能快捷键设置增加",
        },
        {
          test: "8、限制聊天输入内容长度调整",
        },
        {
          test: "9、挖矿修改",
        },
        {
          test: "10、装备格子标识变更",
        },
        {
          test: "11、通用输入框优化",
        },
        {
          test: "12、刺杀优化",
        },
      ],
    },
    {
      title: "客户端更新：新功能",
      data: [
        {
          test: "1、排行榜",
        },
        {
          test: "2、附近的人功能完善",
        },
        {
          test: "3、极品首饰盒",
        },
        {
          test: "4、安全区穿NPC、穿人功能",
        },
      ],
    },
    {
      title: "2020/11/09",
      data: [
        {
          test: "01、增加 技能表2个参数",
        },
        {
          test: "ActRange 技能范围（只针对群体法术，范围默认是1）",
        },
        {
          test:
            "ActRate 技能伤害攻击力倍数 (针对所有有伤害的攻击技能，0：百分比，默认是100，1：具体点数，比如0=120，就是1.2倍伤害；1=50，就是每次多加50点伤害)",
        },
        {
          test: "02、增加 主界面按钮自由摆放功能",
        },
        {
          test: "03、增加 技能狮子吼,火龙烈焰,飓风破,灭天火",
        },
        {
          test: "04、增加 传音筒喊话内容过长滚动显示效果",
        },
        {
          test:
            "05、增加 法师下线魔法盾开启与关闭功能,引擎功能设置-技能魔法-魔法盾中设置",
        },
        {
          test:
            "06、增加 宝宝被攻击主人名称和攻击宝宝玩家名称常量 <$Darlingpet>",
        },
        {
          test: "07、增加 施毒术开启关闭下线中毒效果",
        },
        {
          test: "08、增加 商城常用变量",
        },
        {
          test: "09、增加 拍卖行购买物品触发,竞价触发,获取购买当前物品名称",
        },
        {
          test: "10、增加 自定义按钮悬挂界面位置",
        },
        {
          test: "11、增加 游戏面板调用功能",
        },
        {
          test: "12、增加 客户端变量,可用来做货币和物品数量实时刷新",
        },
        {
          test: "13、修复 在地面放物品数量不对BUG",
        },
        {
          test: "14、修复 #OR命令BUG",
        },
        {
          test: "15、修复 系统自带商店卖物品不显示功能和商店功能解释",
        },
        {
          test: "16、修改 客户端多开限制,在引擎功能设置-其他设置里面设置",
        },
        {
          test: "17、修改 光柱持续时间,在参数设置-时间控制里面设置",
        },
        {
          test: "18、修复 GIVE命令给予叠加物品超过50个数量不对BUG",
        },
        {
          test: "19、修复 套装属性表,填写0属性触发套装黑屏问题",
        },
      ],
    },
    {
      title: "客户端资源：更新",
      data: [
        {
          test: "1、增加宝箱特效",
        },
        {
          test:
            "2、增加地图包使用(详情查看Map地图配置(2020.11.09).zip压缩包)",
        },
        {
          test: "3、补全沙漠遗迹地砖问题",
        },
        {
          test: "4、修复部分新地图问题",
        },
        {
          test: "5、补全小地图配置(会有遗漏，再更新)",
        },
      ],
    },
    {
      title: "客户端更新：修复",
      data: [
        {
          test: "1、修复GM边玩边下资源路径不对bug",
        },
        {
          test: "2、修复尸体状态不可以攻击",
        },
        {
          test: "3、野蛮冲撞调整",
        },
        {
          test: "4、持久提醒优化",
        },
      ],
    },
    {
      title: "客户端更新：优化",
      data: [
        {
          test: "1、移动端 调整技能面板吞噬触摸区域大小",
        },
        {
          test: "2、服务器列表的刚开一秒改为'新'角标",
        },
        {
          test: "3、魔法锁定逻辑调整",
        },
        {
          test: "4、智能半月弯刀调整",
        },
        {
          test: "5、UI资源替换",
        },
        {
          test: "6、称号时间调整",
        },
        {
          test: "7、掉落物的特效加到最上层",
        },
        {
          test: "8、NPC商店按钮点击间隔",
        },
        {
          test: "9、通用道具tips修改",
        },
        {
          test: "10、通用输入框优化",
        },
        {
          test: "11、移动端移动刺杀",
        },
      ],
    },
    {
      title: "客户端更新：新功能",
      data: [
        {
          test: "1、宝箱功能",
        },
        {
          test: "2、浑水摸鱼前端显示",
        },
        {
          test: "3、NPC对话大背景框",
        },
        {
          test: "4、进度条功能",
        },
        {
          test: "5、移动端增加夫妻模式",
        },
        {
          test: "6、任务系统初版",
        },
      ],
    },
    {
      title: "2020/11/02",
      data: [
        {
          test: "01、修复 摆摊物品全部卖出离开视野在进入视野摊位消失问题",
        },
        {
          test: "02、修复 关闭摆摊物品不返回背包问题",
        },
        {
          test: "03、修复 宝宝死亡血条不消失问题",
        },
        {
          test: "04、修复 怪物死亡后人物进入视野出现的BUG",
        },
        {
          test: "05、修复 清理尸体,清理完地面还有怪物名字问题",
        },
        {
          test: "06、修复 自动喝药问题",
        },
        {
          test: "07、修复 千里传音喊话规则,和增加设置喊话间隔时间",
        },
        {
          test: "08、修复 绑定物品和非绑定物品叠加问题",
        },
        {
          test: "09、修复 称号倒计时显示问题",
        },
        {
          test: "10、修复 地图事件触发,跑和走功能BUG",
        },
        {
          test: "11、修复 GM命令保存不生效问题",
        },
        {
          test: "12、修复 移动端镖车不能选中的问题",
        },
        {
          test: "13、修复 召唤宝宝出来不是满血问题",
        },
        {
          test: "14、增加 内挂自动修复,持久提示和背景音效",
        },
        {
          test: "15、增加 开天斩 流星火雨 逐日剑法 群体雷电术技能",
        },
        {
          test: "16、增加 客户端面板显示滚动模式",
        },
        {
          test:
            "17、增加 内挂背景音乐和游戏音乐功能,可以自己再cfg_setup.xls 字段:default 调整默认音量大小",
        },
        {
          test: "18、增加 移动端挖肉图标类型细分",
        },
        {
          test: "19、增加 NPC支持怪物外形代码,和cfg_npclist表结构介绍",
        },
        {
          test: "20、增加 一键回收,回收物品是否有附加极品属性",
        },
        {
          test: "21、增加 检测物品CHECKITEM 检测极品装备功能",
        },
        {
          test: "22、增加 扩展TAKE命令",
        },
        {
          test: "23、增加 扩展GIVE命令",
        },
        {
          test: "24、增加 部分地图参数",
        },
        {
          test: "25、增加 禁止上架拍卖行和摆摊限制",
        },
      ],
    },
    {
      title: "客户端资源更新：",
      data: [
        {
          test: "1、修复新沙巴克皇宫黑屏问题",
        },
        {
          test: "2、增加 10组斗笠 (当然也可以自己用资源工具打包)",
        },
        {
          test: "3、增加武器外观特效，和数据库字段的翅膀一样设置",
        },
        {
          test: "4、增加盛大最新地图《沙漠遗迹》和相关怪物资源",
        },
        {
          test: "5、修改烟花特效ID(4500~4508)修改回(79~87)",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、主界面快捷栏叠加物品显示",
        },
        {
          test: "02、NPC通用输入框优化",
        },
        {
          test: "03、公告增加淡出效果",
        },
        {
          test: "04、小地图增加战斗安全显示",
        },
        {
          test: "05、修改道具Tips和称号时间",
        },
        {
          test: "06、自动喝药优化，自动解包和红蓝互换",
        },
        {
          test: "07、怪物增加钻回状态（食人花/触龙神）",
        },
        {
          test: "08、摆摊功能调整",
        },
        {
          test: "09、挂机优化",
        },
        {
          test: "10、增加召唤物存活状态",
        },
        {
          test: "11、固顶聊天使用队列，并增加走马灯",
        },
        {
          test: "12、内观偏移支持多个文件",
        },
        {
          test: "13、支持GM 地图/音效/特效 边玩边下功能",
        },
        {
          test: "14、新技能调试",
        },
        {
          test: "15、拍卖行可以上架快捷栏物品",
        },
        {
          test: "16、优化PC端怪物太多时的卡顿问题",
        },
        {
          test: "17、脚本解析增加默认红色文本格式",
        },
        {
          test: "18、增加内挂 持久警告",
        },
        {
          test: "19、增加自动修理",
        },
        {
          test: "20、手机端战士刺杀的走位问题",
        },
        {
          test: "21、内挂 药品介绍可配置",
        },
        {
          test: "22、内挂 游戏音乐和音效分开",
        },
        {
          test: "23、自定义文本支持滚动",
        },
        {
          test: "24、自定义UI组件支持更多系统",
        },
        {
          test: "25、增加跳转客户端系统功能，方便GM自己写按钮跳转",
        },
        {
          test: "26、手机端 主界面小地图调整",
        },
        {
          test: "27、技能栏按钮模块支持挂接组件",
        },
        {
          test:
            "28、自定义组件元素支持元变量，会自动刷新，如货币数量，不再需要定时器刷新，具体参考说明书",
        },
        {
          test: "29、获得物品时不再自动解包",
        },
        {
          test: "30、内挂增加自动逐日、自动开天、练功增加秒数",
        },
        {
          test: "31、商城购买支持单次最小数量和单次最大数量",
        },
        {
          test: "32、内挂增加自动隐身术",
        },
        {
          test: "33、修改道具Tips对比",
        },
        {
          test: "34、修改通用Tips图片按钮",
        },
      ],
    },
    {
      title: "2020/10/19",
      data: [
        {
          test: "01、修改 把自己的宝宝杀死",
        },
        {
          test: "02、修改 可以检查玩家所带宠物的数量",
        },
        {
          test: "03、修复 挂机不喝药问题",
        },
        {
          test: "04、修复 称号倒计时显示错误",
        },
        {
          test: "05、修复 物物品备注提示错误",
        },
        {
          test: "06、修改 检测指定宝宝数量",
        },
        {
          test: "07、修改 把自己的宝宝杀死.",
        },
        {
          test: "08、修复 禁言玩家命令",
        },
        {
          test: "09、修复 将指定人物加入发言过滤命令",
        },
        {
          test: "10、修复 系统商店买,卖问题",
        },
        {
          test: "11、修复 脚本杀死石化怪物BUG问题",
        },
        {
          test: "12、修复 赤月恶魔类攻击视野范围判断BUG",
        },
        {
          test: "13、增加 自己宝宝被攻击和攻击别人宝宝触发",
        },
        {
          test: "14、增加 押镖系统",
        },
        {
          test: "15、增加 叠加物品快捷栏显示物品数量",
        },
        {
          test: "16、增加 设置地图的杀怪经验倍数",
        },
        {
          test: "17、增加 检查玩家当前经验值。",
        },
        {
          test: "18、增加 设置杀怪经验倍数 KILLMONEXPRATE",
        },
        {
          test: "19、增加 地图参数",
        },
        {
          test: "20、增加 宝宝七彩变色功能",
        },
        {
          test: "21、增加 自己宝宝被攻击和攻击别人宝宝触发",
        },
        {
          test: "22、增加 特修装备功能",
        },
        {
          test: "23、增加 装备加星功能",
        },
        {
          test: "24、增加 获取星星数量常量",
        },
        {
          test: "25、增加 给角色永久属性接口",
        },
        {
          test: "26、增加 取2个日期之间的天数功能接口",
        },
      ],
    },
    {
      title: "客户端资源更新：",
      data: [
        {
          test:
            "1、修复土城沙巴克地图问题，使用老沙巴克新沙巴克如果使用为n3.map新沙巴克皇宫城墙appr修改ID 904,905,906",
        },
        {
          test: "2、更新怪物类所有资源查看【怪物图鉴】ID",
        },
        {
          test: "3、更新盛大衣服类Hum2,3、武器类Weapon2,3",
        },
        {
          test: "4、更新翅膀特效，数据库Anicount填写ID",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "PC小地图增加战斗/安全",
        },
        {
          test: "02、修改tips和称号时间",
        },
        {
          test: "03、npc通用输入框优化",
        },
        {
          test: "04、修复叠加物品不显示数量",
        },
        {
          test: "05、红蓝药检测方式修改",
        },
        {
          test: "06、法师挂机无技能时使用普攻",
        },
        {
          test: "07、修复PC端主玩家会偏的问题",
        },
        {
          test: "08、挂机优化，更智能，不会断",
        },
        {
          test: "09、尝试处理诈尸问题",
        },
        {
          test: "10、自定义资源下载使用压缩包方式，更快，更方便",
        },
        {
          test: "11、游戏LOGO可以自定义，使用后台上传即可",
        },
        {
          test: "12、清理尸体优化",
        },
        {
          test: "13、优化视野内怪物太多时卡顿问题，选择目标算法优化",
        },
        {
          test: "14、外放版本必须通过登录器才能启动",
        },
        {
          test: "15、增加iOS支付问题",
        },
        {
          test: "16、设置信息分角色存储",
        },
        {
          test: "17、手机端聊天调整，替换喊话频道资源",
        },
        {
          test: "18、滑动容器（垂直方向）默认支持鼠标滚轮",
        },
        {
          test: "19、内观偏移可使用工具打，不用写死了",
        },
        {
          test: "20、增加附近玩家",
        },
        {
          test: "21、增加地图背景音乐",
        },
        {
          test: "22、快捷栏祝福油祝福罐逻辑",
        },
        {
          test: "23、ESC可关闭NPC面板（不需要的可设置参数）",
        },
        {
          test: "24、被顶号提醒",
        },
        {
          test: "25、小地图位置和大小调整",
        },
        {
          test: "26、拍卖行PC端",
        },
      ],
    },
    {
      title: "2020/10/12",
      data: [
        {
          test: "01、增加 获取当前屏幕分辨率常量",
        },
        {
          test: "02、增加 获取当前宝宝名字和等级",
        },
        {
          test: "03、增加 获取当前宝宝数量常量 <$SLAVECOUNT>",
        },
        {
          test: "04、增加 转生变色功能",
        },
        {
          test: "05、增加 内挂单双摇杆自由选择",
        },
        {
          test: "06、增加 删除所有称号功能",
        },
        {
          test:
            "07、增加 站在原地打不死怪物,可以用来做经验小白 Race=120 RaceImg=19",
        },
        {
          test: "08、增加 检测背包矿石品质",
        },
        {
          test: "09、增加 人物身上装备修改持久",
        },
        {
          test: "10、增加 获取当前宝宝名字和宝宝等级",
        },
        {
          test: "11、增加 拍卖行上架,下架触发和禁止上架和下架",
        },
        {
          test: "12、增加 读取文本单行多列",
        },
        {
          test: "13、增加 读取表格功能",
        },
        {
          test: "14、增加 地图参数禁止使用技能",
        },
        {
          test: "15、更新 修改自定义变量排序功能",
        },
        {
          test: "16、修复 护卫杀死人物问题",
        },
        {
          test: "17、修复 NPC方向问题",
        },
        {
          test: "18、修复 按ESC关闭当前窗口问题",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、拍卖行优化",
        },
        {
          test: "02、一些怪物名逻辑调整",
        },
        {
          test: "03、修改强化属性",
        },
        {
          test: "04、挂机优化",
        },
        {
          test: "05、挖矿优化",
        },
        {
          test: "06、游戏内输入法不影响快捷键",
        },
        {
          test: "07、手机端普攻可触发挖矿",
        },
        {
          test: "08、内挂 清理尸体",
        },
        {
          test: "09、内挂 经验过滤",
        },
        {
          test: "10、内挂 自动练功",
        },
        {
          test: "11、BOSS提示",
        },
        {
          test: "12、自定义属性",
        },
        {
          test: "13、增加充值",
        },
        {
          test: "14、单双摇杆",
        },
        {
          test: "15、游戏窗体名使用服务器名",
        },
        {
          test: "16、增加装备对比",
        },
        {
          test: "17、多开限制",
        },
      ],
    },
    {
      title: "2020/09/22",
      data: [
        {
          test: "01、修复 护身符，毒次数使用完不消失问题",
        },
        {
          test: "02、修复 结婚系统",
        },
        {
          test: "03、修复 内挂自动吃药自动使用回城卷",
        },
        {
          test: "04、修改 自动解包按照UnbindList.txt设置的数量解包",
        },
        {
          test: "05、增加 法师和道士挂机状态自动走位功能",
        },
        {
          test: "06、增加 改变人物攻击模式",
        },
        {
          test: "07、增加 挂机脚本命令和触发",
        },
        {
          test: "08、增加 拆解物品功能",
        },
        {
          test: "09、增加 宝宝相关功能脚本",
        },
        {
          test: "10、增加 获取背包物品数量",
        },
        {
          test: "11、增加 拍卖行系统",
        },
        {
          test: "12、增加 商城系统",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、自动挂机优化",
        },
        {
          test: "02、自动挂机增加全图找怪功能",
        },
        {
          test: "03、低血保护修改",
        },
        {
          test: "04、增加拍卖行功能",
        },
        {
          test: "05、毒符互换优化",
        },
        {
          test: "06、增加变色BUFF",
        },
        {
          test: "07、道具使用CD调整",
        },
        {
          test: "08、音效设置改为进度条",
        },
        {
          test: "09、增加掉落物快捷拾取，点击脚下强制拾取",
        },
        {
          test: "10、道士技能自动释放根据毒符判定",
        },
        {
          test: "11、增加双端商城",
        },
      ],
    },
    {
      title: "2020/09/14",
      data: [
        {
          test: "01、增加 客户端控制音量大小功能",
        },
        {
          test: "02、增加 引擎喝药速度控制选项",
        },
        {
          test: "03、增加 技能面板的技能描述在cfg_magicinfo表中修改",
        },
        {
          test: "04、增加 内挂人物显名，怪物显名，显示等级等等功能",
        },
        {
          test: "05、增加 穿戴位置装备唯一序列号常量",
        },
        {
          test: "06、增加 人形怪配置",
        },
        {
          test: "07、增加 游戏在线泡经验功能 setautogetexp",
        },
        {
          test: "08、增加 装备持久0装备不会破碎选项",
        },
        {
          test: "09、增加 DEC INC 对字符型变量操作命令",
        },
        {
          test: "10、增加 人物离线时间常量 <$OFFLINEDAYS>",
        },
        {
          test: "11、增加 摆摊触发功能 ",
        },
        {
          test: "12、修复 自动拾取设置无效问题",
        },
        {
          test: "13、修复 人物死亡后血条不消失问题",
        },
        {
          test: "14、修复 挖矿动作问题",
        },
        {
          test: "15、修复 内挂设置自动使用技能，自动回城，自动喝药功能",
        },
        {
          test: "16、修复 道士自动使用技能佩戴护身符和毒",
        },
        {
          test: "17、修复 人物设置幸运+X伤害最大值",
        },
        {
          test: "18、修复 整理背包的时候类型2的物品放置到快捷栏",
        },
        {
          test: "19、修改 骰子面板宽度",
        },
        {
          test: "20、调整 PC端 物品 装备 字体大小",
        },
        {
          test: "21、更新 强化技能功能",
        },
        {
          test: "22、更新 聚灵珠系统",
        },
        {
          test: "23、更新 书籍表相关",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、修复随机石回城石判定",
        },
        {
          test: "02、自动挖矿修改",
        },
        {
          test: "03、人形怪支持右键查看",
        },
        {
          test: "04、查看部分逻辑屏蔽",
        },
        {
          test: "05、骰子播放优化",
        },
        {
          test: "06、鼠标经过提醒支持^换行",
        },
        {
          test: "07、只显人名、顶戴花翎一些刷新逻辑",
        },
        {
          test: "08、增加职业等级显示设置",
        },
        {
          test: "09、增加技能升级功能",
        },
        {
          test: "10、调整摇杆响应范围",
        },
        {
          test: "11、自动挂机优化",
        },
        {
          test: "12、道士自动毒符调整，支持更多技能自动毒符",
        },
        {
          test: "13、修复技能设置无法选择问题",
        },
        {
          test: "14、自动喝药修复",
        },
      ],
    },
    {
      title: "2020/09/07",
      data: [
        {
          test: "01、修改 攻击力药水魔法力药水等特殊药水写法",
        },
        {
          test: "02、修复 神秘套属性",
        },
        {
          test: "03、修复 已知NPC方向播放问题",
        },
        {
          test: "04、修复 骰子脚本功能",
        },
        {
          test: "05、更新 数据库转换工具",
        },
        {
          test: "06、更新 PC端摆摊功能",
        },
        {
          test: "07、增加 组队开启全图经验共享选项",
        },
        {
          test: "08、增加 服务器系统公告，滚动系统公告",
        },
        {
          test: "09、增加 魔血石、气血石、幻魔石",
        },
        {
          test: "10、增加 精准爆率控制",
        },
        {
          test: "11、增加 镜像副本地图",
        },
        {
          test: "12、增加 祝福罐功能",
        },
        {
          test: "13、增加 NPC窗口面板自定义独立ID打开与关闭触发",
        },
        {
          test: "14、增加 在地图上添加魔法效果",
        },
        {
          test: "15、增加 在人物身上播放魔法效果",
        },
        {
          test: "16、增加 查看人物角色面板脚本",
        },
      ],
    },
    {
      title: "客户端更新",
      data: [
        {
          test: "01、血条显示优化",
        },
        {
          test: "02、增加小天才祝福罐，可用可穿",
        },
        {
          test: "03、新增道具使用类型",
        },
        {
          test: "04、增加骰子功能",
        },
        {
          test: "05、道具Tips优化",
        },
        {
          test: "06、字体调整，双端字体分离",
        },
        {
          test: "07、增加新的公告类型",
        },
        {
          test: "08、场景内玩家支持播放特效",
        },
      ],
    },
    {
      title: "2020/08/31",
      data: [
        {
          test: "01、增加 组队邀请队员输入玩家名字",
        },
        {
          test: "02、增加 称号和顶戴花翎自动补全空白坐标位置",
        },
        {
          test: "03、增加 itemshow支持@跳转",
        },
        {
          test: "04、增加 技能心灵召唤",
        },
        {
          test:
            "05、增加 叠加物品拆分 移动端 包裹长按叠加物品 弹出拆分框 PC端 shift + 鼠标左键 弹出拆分框",
        },
        {
          test:
            "06、增加 叠加物品拖动叠加操作 直接 包裹内拖动同类叠加物品 实现叠加",
        },
        {
          test: "07、增加 整体穿戴取下触发穿戴物品",
        },
        {
          test: "08、增加 装备和物品表W列字段：guangzhu，物品掉落光柱",
        },
        {
          test: "09、增加 在地图上放置物品",
        },
        {
          test: "10、增加 脚本命令设置物品来源",
        },
        {
          test: "11、增加 NPC标签触发回调可以加参数功能",
        },
        {
          test: "12、增加 设置装备和人物绑定状态",
        },
        {
          test: "13、增加 给予带绑定物品规则装备",
        },
        {
          test: "14、增加 脚本建立或删除临时NPC",
        },
        {
          test: "15、增加 编组地图传送",
        },
        {
          test: "16、增加 限次使用物品的次数",
        },
        {
          test: "17、增加 人物装备位置，绑定状态",
        },
        {
          test: "18、增加 屏幕任意坐标位置私人公告信息",
        },
        {
          test: "19、增加 捡取物品修改颜色",
        },
        {
          test: "20、增加 人物位置物品信息显示",
        },
        {
          test: "21、增加 怪物爆物品掉落公告提示 String.ini",
        },
        {
          test: "22、增加 顶戴花翎功能",
        },
        {
          test: "23、修复 自定义OK,命令返回背包和命令强制放入物品问题",
        },
        {
          test: "24、修复 称号系统Reserved字段显示与隐藏称号名字",
        },
        {
          test: "25、修复 自定义输入框限制回车换行实现回车确定功能",
        },
        {
          test: "26、修复 登录账号输入限制到11位",
        },
        {
          test: "27、修复 点到怪物尸体 角色无法移动BUG",
        },
        {
          test: "28、修复 优化沙巴克攻城战系统",
        },
        {
          test: "29、修复 修复沙巴克管理员功能设置",
        },
        {
          test: "30、修复 修复技能升级熟练点达到不触发升级BUG",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、没宝宝时不响应宝宝模式快捷键",
        },
        {
          test: "02、UI编辑器优化，增加EquipShow",
        },
        {
          test: "03、增加新装备类型",
        },
        {
          test: "04、攻城区域阻挡动态刷新",
        },
        {
          test: "05、Tips增加绑定",
        },
        {
          test: "06、增加自动挖矿",
        },
        {
          test: "07、增加掉落物光柱",
        },
        {
          test: "08、掉落物拾取可由内挂控制",
        },
        {
          test: "09、挂机功能优化",
        },
        {
          test: "10、移动端道具拆分",
        },
        {
          test: "11、增加道具叠加",
        },
        {
          test: "12、组队优化调整",
        },
      ],
    },
    {
      title: "客户端资源更新：",
      data: [
        {
          test: "01、官方地图全套更换",
        },
        {
          test: "02、所有.map文件小写",
        },
        {
          test: "03、增加心灵召唤技能特效",
        },
        {
          test: "04、增加心灵召唤icon图标 id 70",
        },
        {
          test: "05、增加摆摊资源(buff)",
        },
        {
          test: "06、增加光柱特效",
        },
        {
          test: "07、增加顶戴花翎特效",
        },
      ],
    },
    {
      title: "2020/08/24",
      data: [
        {
          test: "01、增加 OK框物品关联 SetUpgradeItem",
        },
        {
          test: "02、增加 捡取物品关联 LINKPICKUPITEM",
        },
        {
          test: "03、增加 全景小地图自动寻路功能和右键传送功能",
        },
        {
          test:
            "04、更新 客户端特效模型类型0.特效 1.npc 2.怪物 3.技能 4.人物 5.武器 6.翅膀 7.发型",
        },
        {
          test: "05、增加 支持NPC以全局变量命名同步更新全局变量值",
        },
        {
          test: "06、增加 内挂拾取功能",
        },
        {
          test: "07、增加 内挂平滑模式功能",
        },
        {
          test: "08、增加 全屏怪物血条显示",
        },
        {
          test: "09、增加 调整物品名字颜色",
        },
        {
          test: "10、增加 称号系统",
        },
        {
          test:
            "11、道具表和装备表增加pickset字段，控制道具掉落展示和自动拾取",
        },
        {
          test: "12、新增Envir\\Data\\cfg_pick_set.xls内挂捡取分类名称",
        },
        {
          test: "13、组类别#掉落显示#自动拾取",
        },
        {
          test: "14、组类别=data/cfg_pick_set.xls 里面的组ID",
        },
        {
          test: "15、掉落显示=0,1 0代表不显示 1代表显示",
        },
        {
          test: "16、自动拾取=0,1 0代表不捡取 1代表捡取",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、增加顶戴花翎",
        },
        {
          test: "02、手机端挖肉类型细分",
        },
        {
          test: "03、走路时不可穿人/怪/NPC",
        },
        {
          test: "04、修复沙巴克城门层级渲染异常",
        },
        {
          test: "05、PC端平滑模式可设置",
        },
        {
          test: "06、摇杆优化",
        },
        {
          test: "07、自动挂机时增加特效表现",
        },
        {
          test: "08、小地图增加右键点击传送",
        },
        {
          test: "09、小地图寻路增加聊天栏提醒",
        },
        {
          test: "10、移动端适配优化",
        },
        {
          test: "11、PC端攻击时不判断目标是否可攻击",
        },
      ],
    },
    {
      title: "2020/08/17",
      data: [
        {
          test: "01、增加 物品来源设置",
        },
        {
          test: "02、增加 背包获得物品信息提示",
        },
        {
          test: "03、增加 装备持久消失触发",
        },
        {
          test: "04、增加 可以挖肉类型怪物 Race 51 52 53 90 105 106",
        },
        {
          test: "05、增加 检测指定范围内人物数量",
        },
        {
          test: "06、增加 自定义变量排序",
        },
        {
          test: "07、增加 设置限时物品",
        },
        {
          test: "08、修复 自定义变量申明和操作问题",
        },
        {
          test: "09、修复 沙巴克炼武器功能",
        },
        {
          test: "09、更新 特殊物品1=1次，还原为 1000=1次",
        },
        {
          test: "10、更新 杀死怪物常量分带数字显示和不带数字显示",
        },
      ],
    },
    {
      title: "客户端更新：",
      data: [
        {
          test: "01、摆摊优化",
        },
        {
          test: "02、移动端 是否可挖肉根据怪物类型细分，挖肉操作优化",
        },
        {
          test: "03、UI编辑器优化",
        },
        {
          test: "04、增加叠加道具拆分功能",
        },
        {
          test: "05、电脑端小地图鼠标经过显示地图坐标",
        },
        {
          test: "06、电脑端 鼠标控制移动逻辑优化，更灵敏",
        },
        {
          test: "07、移动端 摇杆增加走跑设置",
        },
        {
          test: "08、tips增加沙巴克标识",
        },
        {
          test: "09、主界面小地图增加附近人/怪/NPC",
        },
      ],
    },
    {
      title: "2020/08/10",
      data: [
        {
          test: "01、更新 修复攻击触发 ",
        },
        {
          test: "02、更新 修复机器人播放光环效果问题",
        },
        {
          test: "03、更新 修复PC端怪物抖动频率高问题",
        },
        {
          test: "04、更新 修复更新地图安全区特效",
        },
        {
          test: "05、更新 修复客户端手镯戒指穿戴替换问题 ",
        },
        {
          test: "06、更新 修复客户端怪物死亡显高亮,显示怪物名称",
        },
        {
          test: "07、增加 使用技能触发MagSelfFunc",
        },
        {
          test: "08、增加 PC端组队,加好友冒泡功能",
        },
        {
          test: "09、增加 检测人物PK值",
        },
        {
          test: "10、增加 红名死亡回城点",
        },
        {
          test: "11、增加 组队成员邀请玩家队长同意",
        },
        {
          test: "12、增加 获取组队成员数量",
        },
      ],
    },
    {
      title: "手机端 ",
      data: [
        {
          test: "01、宝宝操作UI调整",
        },
        {
          test: "02、增加强攻",
        },
        {
          test: "03、增加时间",
        },
        {
          test: "04、修改组队需要队长同意",
        },
        {
          test: "05、增加挖肉功能",
        },
      ],
    },
    {
      title: "电脑端",
      data: [
        {
          test: "01、修复死亡怪物可以选择bug",
        },
        {
          test: "02、死亡玩家/怪物鼠标放上去也可以高亮",
        },
        {
          test: "03、好友面板更换",
        },
        {
          test: "04、小地图调整",
        },
        {
          test: "05、增加时间",
        },
        {
          test: "06、增加挖肉功能",
        },
        {
          test: "07、键盘按钮支持按住不放持续响应",
        },
        {
          test: "08、增加称号功能",
        },
      ],
    },
    {
      title: "2020/08/03",
      data: [
        {
          test: "01、增加 机器人分和秒",
        },
        {
          test: "02、增加 自定义命令",
        },
        {
          test: "03、增加 获取用户自定义命令输入参数<$PARAM(0)>",
        },
        {
          test: "04、增加 怪物人物攻击触发",
        },
        {
          test: "05、增加 动态地图连接点 ",
        },
        {
          test: "06、修复 人物死亡上线回到安全区",
        },
        {
          test: "07、增加 检测人物攻击模式",
        },
        {
          test: "08、增加 强制人物的攻击模式 ",
        },
        {
          test: "09、增加 仓库开锁新格子功能 ",
        },
        {
          test: "10、更新 修改创建行会条件",
        },
        {
          test: "11、更新 播放音乐脚本对应表功能",
        },
        {
          test: "12、更新 屏幕中间大字体新增7=组队",
        },
        {
          test: "13、更新 初始化行会触发",
        },
        {
          test: "14、更新 自定义保存变量需要先声明",
        },
      ],
    },
    {
      title: "客户端更新",
      data: [
        {
          test: "01、聊天固顶消息支持背景色",
        },
        {
          test: "02、PC端声音设置功能",
        },
        {
          test: "03、戒指手镯替换逻辑",
        },
        {
          test: "04、PC端小地图功能",
        },
        {
          test: "05、增加删除倒计时公告功能",
        },
        {
          test: "06、PC端血蓝增加数值显示",
        },
        {
          test: "07、修复刚进入显示在 比奇40:40bug",
        },
        {
          test: "08、更新客户端召唤宝宝按钮",
        },
        {
          test: "09、增加强攻按钮",
        },
        {
          test: "10、增加PC端,全景小地图",
        },
        {
          test: "11、移动端快捷栏修改成6个",
        },
      ],
    },
    {
      title: "2020/07/27",
      data: [
        {
          test: "01、更新 修复行会系统",
        },
        {
          test: "02、更新 修复组队系统",
        },
        {
          test: "03、更新 修复商铺系统",
        },
        {
          test: "04、更新 组队人数和显示组队成员常量",
        },
        {
          test: "05、更新 清理地图上指定名字的物品",
        },
        {
          test: "06、更新 清除地图中的怪物",
        },
        {
          test: "07、更新 随机杀死地图中的怪物",
        },
        {
          test: "08、更新 获取当前物品的附加元素属性",
        },
        {
          test: "09、更新 检查一个地图内的怪物数量",
        },
        {
          test: "10、更新 清除指定地图里的怪物",
        },
        {
          test: "11、更新 增加OK框获取框内叠加物品数量",
        },
      ],
    },
    {
      title: "2020/07/18",
      data: [
        {
          test: "01、更新 增加自定义按钮图标",
        },
        {
          test: "02、更新 增加自定义OK框功能",
        },
        {
          test: "03、更新 任意地图杀死怪物触发",
        },
        {
          test: "04、更新 指定地图杀死怪物时触发",
        },
        {
          test: "05、更新 检查正在被自己攻击的怪物的名字",
        },
        {
          test: "06、更新 检查人物是否在攻城区域",
        },
        {
          test: "07、更新 所有行会在当晚同时攻城",
        },
        {
          test: "08、更新 修复检测背包物品 给与物品 拿走物品功能",
        },
        {
          test: "09、更新 修复套装触发数量问题",
        },
        {
          test: "10、更新 人物杀怪爆率倍数",
        },
        {
          test: "11、更新 CHECKACCOUNTLIST 检测账号唯一ID (非登录账号ID)",
        },
        {
          test: "12、更新 ADDACCOUNTLIST 增加账号唯一ID (非登录账号ID)",
        },
        {
          test: "13、更新 增加装备表道具表物品规则 R列增加字段:Article",
        },
        {
          test: "14、更新 刷新包裹脚本命令",
        },
        {
          test: "15、更新 自动寻路脚本命令",
        },
        {
          test: "16、更新 怪物死亡坐标 X Y常量",
        },
        {
          test: "17、更新 增加装备表和道具表的备注再U列增加字段:Desc",
        },
      ],
    },
    {
      title: "2020/07/10",
      data: [
        {
          test: "01、更新 捡取物品触发",
        },
        {
          test: "02、更新 更改人物颜色",
        },
        {
          test: "03、更新 自定义输入内容",
        },
        {
          test: "04、更新 获取物品的附加值",
        },
        {
          test: "05、更新 检查地图内的人物数量",
        },
        {
          test: "06、更新 检测地图范围怪物数量",
        },
        {
          test:
            "07、更新 套装功能特殊属性，详情请查看道具表 cfg_suit 里面的说明",
        },
        {
          test: "08、更新 属性表，装备属性排序位置，字体颜色显示",
        },
        {
          test: "09、更新 属性新增 增加韧性、暴击抵抗",
        },
        {
          test: "10、更新 PC端技能面板可以使用鼠标滚轮",
        },
        {
          test: "11、更新 自动捡物被阻碍时先打怪",
        },
        {
          test: "12、更新 更新跑马灯公告",
        },
        {
          test: "13、更新 增加药品系列解包功能",
        },
        {
          test: "14、更新 怪物表cfg_monster 第一列需要增加IDX列",
        },
        {
          test: "15、更新 发送屏幕中间大字体信息",
        },
        {
          test: "16、更新 发送屏幕滚动信息",
        },
        {
          test: "17、更新 发送聊天框固顶信息",
        },
      ],
    },
    {
      title: "2020/07/04",
      data: [
        {
          test: "01、更新 删除非本职业的所有技能",
        },
        {
          test: "02、更新 清除人物的所有技能",
        },
        {
          test: "03、更新 清除列表内容",
        },
        {
          test: "04、更新 获取物品的附加属性值",
        },
        {
          test: "05、更新 更换性别",
        },
        {
          test: "06、更新 更改头发类型",
        },
        {
          test: "07、更新 扩展定时器增加到0-255",
        },
        {
          test: "08、更新 过虑全服提示信息",
        },
        {
          test: "09、更新 游戏中打开网站",
        },
        {
          test: "10、更新 调整物品元素属性",
        },
        {
          test: "11、更新 调整人物元素属性",
        },
        {
          test: "12、更新 道具表药品设置详情",
        },
        {
          test: "13、更新 脚本ItemShow物品显示",
        },
        {
          test: "14、更新 装备表全部属性整理",
        },
        {
          test: "15、更新 自定义OK框",
        },
      ],
    },
    {
      title: "2020/06/11",
      data: [
        {
          test: "01、更新 检测是否在摆摊",
        },
        {
          test: "02、更新 检测是否是本月的第几天",
        },
        {
          test: "03、更新 检测现在是几月",
        },
        {
          test: "04、更新 离线挂机",
        },
        {
          test: "05、更新 检测人物是否是离线挂机",
        },
        {
          test: "06、更新 检查人物登录IP",
        },
        {
          test: "07、更新 增加<$IPADDR>",
        },
        {
          test: "08、更新 调整人物经验点数",
        },
        {
          test: "09、更新 检测人物是否重叠",
        },
        {
          test: "10、更新 修改物品的附加属性值",
        },
        {
          test: "11、更新 检测人物幸运值",
        },
        {
          test: "12、更新 随机验证码",
        },
        {
          test: "13、更新 人物小退触发",
        },
        {
          test: "14、更新 把行会加入攻城列表",
        },
        {
          test: "15、更新 多级脚本使用",
        },
        {
          test: "16、更新 检测人物是否在线",
        },
        {
          test: "17、更新 自动穿装备和取装备",
        },
      ],
    },
    {
      title: "2020/06/3",
      data: [
        {
          test: "01、更新 脚本命令刷怪",
        },
        {
          test: "02、更新 创建新目录",
        },
        {
          test: "03、更新 调整人物属性",
        },
        {
          test: "04、更新 调整人物HP\\MP",
        },
        {
          test: "05、更新 检查是被怪物还是人物杀死的",
        },
        {
          test: "06、更新 检查字符串是否在指定文件中",
        },
        {
          test: "07、更新 取得随机字符串",
        },
        {
          test: "08、更新 从指定文件中增加,删除字符串",
        },
        {
          test: "09、更新 检测被自己杀死的宝宝的名字",
        },
        {
          test: "10、更新 检查人物杀死怪物的名字",
        },
        {
          test: "11、更新 增加人物名在列表中",
        },
        {
          test: "12、更新 检测人物名单",
        },
        {
          test: "13、更新 百分比计算脚本",
        },
        {
          test: "14、更新 检查是否为组长",
        },
        {
          test: "15、更新 检测是否进入攻城范围",
        },
        {
          test: "16、更新 检测自己和宝宝之间的距离",
        },
        {
          test: "17、更新 把自己的宝宝杀死",
        },
        {
          test: "18、更新 检查当前地图中的人物是否属于同一行会",
        },
        {
          test: "19、更新 检测是否正在攻城",
        },
        {
          test: "20、更新 检测当前人物是否佩带指定物品",
        },
        {
          test: "21、更新 检查沙巴克占领天数",
        },
        {
          test: "22、更新 检测行会成员人数",
        },
        {
          test: "23、更新 检查人物组队人数",
        },
        {
          test: "24、更新 检查玩家是否为行会老大",
        },
        {
          test: "25、更新 检测指定人物背包空格数量",
        },
        {
          test: "26、更新 检查人物是否学习了某项魔法",
        },
        {
          test: "27、更新 检查正在穿身上装备的名字",
        },
        {
          test: "28、更新 检查正在脱身上装备的名字",
        },
        {
          test: "29、更新 取指定位置的装备名字",
        },
        {
          test: "30、更新 检查人物身上指定位置是否戴物品",
        },
        {
          test: "31、更新 延时，跳转功能",
        },
        {
          test: "32、更新 建立新行会",
        },
        {
          test: "33、更新 检查玩家是否为沙城老大",
        },
        {
          test: "34、更新 增加人物IP在列表中",
        },
        {
          test: "35、更新 删除人物IP在列表中",
        },
        {
          test: "36、更新 增加人物帐号ID在列表中",
        },
        {
          test: "37、更新 删除人物帐号ID在列表中",
        },
        {
          test: "38、更新 增加人物名在列表中",
        },
        {
          test: "39、更新 删除人物名字在列表中",
        },
        {
          test: "40、更新 优化自定义保存变量路径,方便合区",
        },
        {
          test: "41、更新 删除文本某一行，保留行号",
        },
        {
          test: "42、更新 设置攻击力倍数",
        },
        {
          test: "43、更新 自己宝宝死亡时触发",
        },
        {
          test: "44、更新 检测字符串长度",
        },
        {
          test: "45、更新 脚本控制怪物攻城",
        },
      ],
    },
    {
      title: "2020/06/1",
      data: [
        {
          test: "01、货币相关：将货币ID修改为货币名称",
        },
        {
          test: "02、检查当前所在地图的名字",
        },
        {
          test: "03、检查正在被自己攻击的怪物的名字",
        },
        {
          test: "04、增加#OR满足任意条件执行",
        },
        {
          test: "05、一键回收包裹物品的脚本命令",
        },
        {
          test: "06、把人物身上装备放入背包中",
        },
      ],
    },
    {
      title: "2020/05/27",
      data: [
        {
          test: "01、更新 给字符串增加空格",
        },
        {
          test: "02、更新 字符串比较处理",
        },
        {
          test: "03、更新 变量数据传递MOVEX",
        },
        {
          test: "04、更新 调整人物属性",
        },
        {
          test: "05、更新 获取对面人物的名字",
        },
        {
          test: "06、更新 自定义颜色文字发送",
        },
        {
          test: "07、更新 检查字符串是否在指定文件中",
        },
        {
          test: "08、更新 字符串比较处理",
        },
        {
          test: "09、更新 字符串替换",
        },
        {
          test: "10、更新 检测血量，魔法百分比",
        },
        {
          test: "11、更新 检测字符串长度",
        },
        {
          test: "12、更新 检查人物HP值的上限及下限值",
        },
        {
          test: "13、更新 检查字符串是否在指定文件中",
        },
      ],
    },
    {
      title: "2020/05/15",
      data: [
        {
          test: "01、增加升级触发",
        },
        {
          test: "02、增加大退触发",
        },
        {
          test: "03、增加杀死对方宝宝触发",
        },
        {
          test: "04、增加杀人触发",
        },
        {
          test: "05、增加跑步、走路触发",
        },
        {
          test: "06、增加@Startup触发",
        },
        {
          test: "07、增加指定人物触发",
        },
        {
          test: "08、增加地图触发事件配置",
        },
        {
          test: "09、增加扔物品和捡取物品触发",
        },
        {
          test: "10、增加杀死或人物爆物品时触发",
        },
        {
          test: "11、增加GOTOLABEL触发",
        },
        {
          test: "12、增加创建组队时触发",
        },
        {
          test: "13、增加获得经验时触发",
        },
        {
          test: "14、增加自定义采集触发",
        },
        {
          test: "15、增加字符串替换功能",
        },
        {
          test: "16、增加取字符串在列表中的下标",
        },
      ],
    },
    {
      title: "2020/04/28",
      data: [
        {
          test: "01、增加集体传送脚本命令 ",
        },
        {
          test: "02、更换DBserver.exe，PC和移动端造成顶号问题",
        },
        {
          test: "03、增加从文件中随机取文本 ",
        },
        {
          test: "04、增加写入指定文本文件 ",
        },
        {
          test: "05、增加读取文本内容到变量 ",
        },
        {
          test: "06、增加多级脚本使用 ",
        },
        {
          test: "07、修复镖车死亡后 接镖的人不获得失败赔偿奖励",
        },
        {
          test: "08、修复杀死镖车后 杀死镖车的人不获得杀怪奖励",
        },
      ],
    },
    {
      title: "2020/04/27",
      data: [
        {
          test: "01、增加NPC特修RepairAll身上脚本",
        },
        {
          test: "02、增加押镖系统",
        },
        {
          test: "03、增加自动穿背包中的装备",
        },
      ],
    },
    {
      title: "2020/04/25",
      data: [
        {
          test: "01、增加脚本 穿戴、取下触发",
        },
        {
          test: "02、修复显示 SETRANKLEVELNAME %s",
        },
        {
          test: "03、增加脚本检测、修改物品的附加属性值 ",
        },
        {
          test: "04、修复messagebox，PC端乱码问题",
        },
        {
          test: "05、增加NPC命令AbilityAdd附加属性",
        },
        {
          test: "06、增加技能触发",
        },
      ],
    },
    {
      title: "2020/04/18",
      data: [
        {
          test: "01、还原MerChant.txt配置",
        },
        {
          test: "02、还原MapInfo.txt配置",
        },
        {
          test: "03、解决@move佩戴传送戒指无效",
        },
        {
          test: "04、增加获取物品原始各项数据库字段值参数",
        },
        {
          test: "说明：获取物品原始各项数据库字段值参数",
        },
      ],
    },
    {
      title: "PC端修复",
      data: [
        {
          test: "01、地上金币显示异常",
        },
        {
          test: "02、地上物品颜色未同步",
        },
        {
          test: "03、野蛮撞击后，怪物名称变成双行名称",
        },
        {
          test: "04、人物PK名字变色其他玩家未刷新(离开视野还原变白了)",
        },
        {
          test: "06、进入游戏公告内容异常",
        },
        {
          test: "07、卫士、带刀护卫显示不正常",
        },
        {
          test: "08、快捷栏6个数字没有显示",
        },
        {
          test: "09、小地图显示：怪物蓝色改为红色，对方玩家改黄色点",
        },
        {
          test: "10、对方玩家发型不正确(外观、内观)",
        },
      ],
    },
  ];
